import React, { useEffect, useRef, useState, useCallback } from "react";
import Select from "react-select";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { formatDate, formatDateTime, formattedDate, formattedDateLong } from "../Date";
import { customSortByKey, formatCurrencyIndian, formatRoundoff2D, handleAllError, CustomImageModal, downloadImprestExpenseExcel } from "../CustomFunctions";
import { CSSForFilterDropdown } from "../CustomUtilities";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { AddwithBlueCircle, CircularGrid, DownloadIcon, Employee, SearchBig, Sort } from "../AllSvg";
import { ToastContainer, toast } from "react-toastify";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { DownloadTableExcel } from "react-export-table-to-excel";


const oneMonthAgo = new Date();
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
const defaultFromDate = `${oneMonthAgo.getFullYear()}-${String(oneMonthAgo.getMonth() + 1).padStart(2, "0")}-${String(oneMonthAgo.getDate()).padStart(2, "0")}`;
const defaultToDate = formattedDate;

const AddProjectFromImprest = ({ i, departmentLists, getFilterProjects, setFormData, setInputState, setNewProject }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        setShow(true)
    };

    const [loading, setLoading] = useState(false); //loading logic
    const handleSubmit = async (e) => {
        e.preventDefault();
        const updatedformvalue = {
            // ...formData,
            project_code: i.ref_project_code,
            project_name: i.ref_project_name,
            department: i.department,
            sub_company: sessionStorage.getItem('company_id'),
            created_by: sessionStorage.getItem('emp_code'),
            created_at: new Date().toISOString(),
        };
        // console.log("updatedformvalue")
        // console.log(updatedformvalue)
        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.post(`${BASE_URL}/wfm/projectcode/`, updatedformvalue);

            if (res.status === 200) {
                // Fetch the newly created project details
                const newProjectResponse = await axios.get(`${BASE_URL}/wfm/projectcode/${i.department}/${sessionStorage.getItem("company_id")}/`);
                const newProjectList = newProjectResponse.data || [];

                // Find the newly created project in the updated project list
                const newlyCreatedProject = newProjectList.find(
                    project => project.project_code === i.ref_project_code
                );

                if (newlyCreatedProject) {
                    // Set all four values in formData and inputState
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        project_id: newlyCreatedProject.id,
                        project_name: newlyCreatedProject.project_name,
                        ref_project_code: newlyCreatedProject.project_code,
                        ref_project_name: newlyCreatedProject.project_name,
                    }));

                    setInputState(prevInputState => ({
                        ...prevInputState,
                        project_id: "green",
                        project_name: "green",
                        ref_project_code: "green",
                        ref_project_name: "green",
                    }));
                }

                // Refresh the project list in the outer component
                await getFilterProjects(i.department);
                setNewProject(false)
                // Close the modal
                handleClose();
            } else {
                alert(res);
            }
        } catch (err) {
            handleAllError(err)
        } finally {
            setLoading(false); //loading logic
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button type='button' title="Add New Project" className="jd-heading-main font-weight600" onClick={handleShow} >
                <AddwithBlueCircle /> Add The New Project : {i.ref_project_code}-{i.ref_project_name}<span className="required">*</span>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Project Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h3 className="task-Tab-heading   font-weight500    font-size-heading">
                                Are You sure you want to add project:
                            </h3>

                            <p>Project Code : {i.ref_project_code}</p>
                            <p>Project Name : {i.ref_project_name}</p>
                            <p>For Department : {departmentLists.find(t => t.id === i.department)?.title || ""}</p>


                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel font-weight500   "
                                    onClick={handleClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >

        </>

    );
}

const EmployeeImprestExpenseDashboard = () => {

    const location = useLocation();
    let filters_employee = location.state?.filter_employee !== null ? location.state?.filter_employee : 'null';
    let filters_department = location.state?.filter_department !== null ? location.state?.filter_department : `${sessionStorage.getItem("department")}`;
    let filters_subCompany = location.state?.filter_subCompany !== null ? location.state?.filter_subCompany : `${sessionStorage.getItem("company_id")}`;
    let filters_empstatus = location.state?.filter_empstatus !== null ? location.state?.filter_empstatus : 'active';
    let filters_fromdate = location.state?.filter_fromdate != null ? location.state?.filter_fromdate : defaultFromDate;
    let filters_todate = location.state?.filter_todate != null ? location.state?.filter_todate : defaultToDate;

    const [selectedEmployee, setSelectedEmployee] = useState(sessionStorage.getItem('emp_code'));
    const [selectedProject, setSelectedProject] = useState(null);
    const [employeeGet, setEmployeeGet] = useState(filters_employee || 'null');
    // const [selectedDepartment, setSelectedDepartment] = useState(filters_department || `${sessionStorage.getItem("department")}`);
    const [selectedDepartment, setSelectedDepartment] = useState(filters_department || `null`);
    const [selectedSubCompany, setSubCompany] = useState(filters_subCompany || `${sessionStorage.getItem("company_id")}`);
    const [active, setActive] = useState(filters_empstatus || 'active');
    const [fromdate, setFromDate] = useState(filters_fromdate || defaultFromDate);
    const [todate, setToDate] = useState(filters_todate || defaultToDate);

    const abortControllerRef = useRef(null);
    const requestIdRef = useRef(0);
    const [dates, setDates] = useState(0)
    // setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic
    const [imprestExpenseData, setImprestExpenseData] = useState([]);

    // const getImprestExpenseData = async () => {
    //     setBuffering(true); //buffering logic // Start Buffering
    //     try {
    //         // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
    //         const res = await axios.get(
    //             // `${BASE_URL}/wfm/imprestexpenseadmindashboard/${selectedEmployee}/${selectedDepartment}/${selectedSubCompany}/${active}/`
    //             `${BASE_URL}/wfm/imprestexpenseadmindashboard/${selectedEmployee}/${selectedDepartment}/${selectedSubCompany}/${active}/${fromdate}/${todate}/`
    //         );
    //         setImprestExpenseData(res.data);
    //     } catch (err) {
    //         handleAllError(err);
    //     } finally {
    //         setBuffering(false);// End Buffering
    //     }
    // };

    const getImprestExpenseData = async (activeFromDate = fromdate, activeToDate = todate) => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        const currentRequestId = ++requestIdRef.current;

        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
            const res = await axios.get(
                `${BASE_URL}/wfm/imprestexpenseadmindashboard/${selectedEmployee}/${selectedDepartment}/${selectedSubCompany}/${active}/${activeFromDate}/${activeToDate}/`,
                { signal: abortControllerRef.current.signal }
            );
            if (currentRequestId === requestIdRef.current) {
                setImprestExpenseData(res.data);
            }
        } catch (err) {
            if (axios.isCancel(err) || err.name === 'CanceledError') {
                return;
            }
            if (currentRequestId === requestIdRef.current) {
                handleAllError(err);
                setImprestExpenseData([]);
            }
        } finally {
            if (currentRequestId === requestIdRef.current) {
                setBuffering(false);// End Buffering
            }
        }
    };

    // useEffect(() => {
    //     getImprestExpenseData();
    // }, [employeeGet, selectedDepartment, selectedSubCompany, active, fromdate, todate]);
    useEffect(() => {
        // If one date is selected and the other is null/empty, wait until both are selected or both are null
        if ((fromdate !== "null" && todate === "null") || (fromdate === "null" && todate !== "null")) {
            return;
        }
        if (fromdate !== "null" && todate !== "null" && new Date(fromdate) > new Date(todate)) {
            return;
        }

        setBuffering(true);

        const timer = setTimeout(() => {
            getImprestExpenseData(fromdate, todate);
        }, 300);

        return () => clearTimeout(timer);
    }, [employeeGet, selectedDepartment, selectedSubCompany, active, fromdate, todate]);


    const [allemployee, setAllemployee] = useState([]);
    const getEmpcode = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setAllemployee(sortedList);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
    }, [active, selectedSubCompany]);

    const options = allemployee
        .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.emp_code,
            label: `${i.emp_code} - ${i.name}`,
        }));

    const nullOption = { value: 'null', label: 'Select Employee Code' };

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            // Set selected employee code(s)
            setEmployeeGet(selectedOption.value);
        } else {
            setEmployeeGet(null); // Clear selection
        }
    };


    return (
        <div className="attendance-history-cont">
            <div className="attendance-subcont">
                <div className="field-cont">
                    <div className="field-cont-div">
                        <div className="date-uppercase ">
                            <input
                                className="attendance-input-field width-10vw date-field date-field-filter"
                                placeholder="From Date"
                                type="date"
                                value={fromdate === "null" ? "" : fromdate}
                                onChange={(e) => setFromDate(e.target.value || "null")}
                            />
                        </div>
                        <hr className="field-cont-hr" />
                    </div>
                    <div className="field-cont-div">
                        <div className="date-uppercase ">
                            <input
                                className="attendance-input-field width-10vw date-field date-field-filter"
                                placeholder="To Date"
                                type="date"
                                value={todate === "null" ? "" : todate}
                                onChange={(e) => setToDate(e.target.value || "null")}
                            />
                        </div>
                        <hr className="field-cont-hr" />
                    </div>
                </div>
                <div className="btn-cont"></div>
            </div>
            {/* <div className="attendance-subcont">
                <div className="field-cont">

                    <div className="field-cont-div">
                        <Select
                            className="attendance-input-field width-20vw"
                            // options={[{ value: "null", label: "All" }, ...projects]}
                            options={[{ value: "null", label: "All" },]}
                            placeholder="Select Project Code"
                            value={selectedProject}
                            onChange={handleProjectChange}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    color: '#707070',
                                    outline: 'none',
                                    border: 'none',
                                    padding: '0.6rem 0.5rem',
                                    textTransform: 'capitalize',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: 'none',
                                    },
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: '#707070',
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: '#707070',
                                }),
                                dropdownIndicator: (provided) => ({
                                    ...provided,
                                    filter: 'invert(50%)',
                                    cursor: 'pointer',
                                    left: '9.5rem',
                                    width: '20px',
                                    height: '20px',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999, // Ensure dropdown menu appears above other elements
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    color: state.isSelected ? '#2576bc' : '#707070',
                                    backgroundColor: state.isSelected ? 'rgba(37,118,188,0.1)' : 'white',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#2576bc',
                                        color: 'white',
                                    },
                                }),
                            }}
                        />
                        <hr className="field-cont-hr" />
                    </div>
                </div>
                <div className="btn-cont"></div>
            </div> */}

            {/* Data Table */}
            <div className="table-css-white-background-new scroll-container-table">
                <table className="">
                    <thead
                        style={{
                            position: "sticky",
                            top: "0",
                            backgroundColor: "#fff",
                            zIndex: "10",
                        }}
                    >
                        <tr className="custom-table-head-tr-0P">
                            <th className="table-heading">S. No.</th>
                            {/* <th className="table-heading">Employee Details</th> */}
                            <th className="table-heading">Project Reference</th>
                            <th className="table-heading text-center">Imprest Details</th>
                            <th className="table-heading">Imprest Amount</th>
                            <th className="table-heading">Imprest Received Date</th>
                            <th className="table-heading">Imprest Approval Status</th>
                            <th className="table-heading text-center">Expense Details</th>
                            <th className="table-heading text-center">Expense Amount</th>
                            <th className="table-heading">Expense Bills Date Range</th>
                            <th className="table-heading">Expense Approval Status</th>
                        </tr>
                    </thead>
                    {/* {buffer ? <div className="spinner"></div> : 
                        <tbody>
                            {imprestExpenseData?.map((item, index) => {
                                const expenseData = item?.expense_data?.length > 0 ? item.expense_data[0] : null;

                           
                                const DatesList = expenseData?.expense_details?.length > 0
                                    ? expenseData.expense_details.map(exp => exp.date).sort((a, b) => new Date(a) - new Date(b))
                                    : [];

                                const FirstBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[0]);
                                const LastBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[DatesList.length - 1]);
 */}
                    <tbody>
                        {buffer ? (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center", padding: "50px 20px" }}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                        <div className="spinner" style={{ margin: "0 auto" }}></div>
                                        <span style={{ color: "#2576bc", fontWeight: "600", fontSize: "14px" }}>
                                            Loading data, please wait...
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ) : imprestExpenseData?.length === 0 ? (
                            <tr>
                                <td colSpan="10" style={{ textAlign: "center", padding: "40px 20px", color: "#888", fontSize: "14px" }}>
                                    No Records Found
                                </td>
                            </tr>
                        ) : (
                            imprestExpenseData?.map((item, index) => {
                                const expenseData = item?.expense_data?.length > 0 ? item.expense_data[0] : null;

                                // Check if expense details exist before mapping
                                const DatesList = expenseData?.expense_details?.length > 0
                                    ? expenseData.expense_details.map(exp => exp.date).sort((a, b) => new Date(a) - new Date(b))
                                    : [];

                                const FirstBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[0]);
                                const LastBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[DatesList.length - 1]);

                                return (
                                    <>
                                        <tr className="custom-table-head-td" key={index}>
                                            <td className="table-body">{index + 1}</td>
                                            {/* <td className="table-body" style={{ textAlign: "center" }}>
                                                <CustomImageModal customStyle>
                                                    {item?.profilepic ? (
                                                        <img
                                                            src={`${IMAGE_URL}${item?.profilepic}`}
                                                            alt="profile" className='profile-img'
                                                        />
                                                    ) : (
                                                        <UserDefaultLogo user={{ name: item.emp_name, profilepic: item.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                                                    )}
                                                </CustomImageModal>
                                                <p>{item.empcode}-{item.emp_name}</p>
                                            </td> */}



                                            {/* <td className="table-body">
                                                {item.mantra_project_details?.mantra_project_id ?
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {item.mantra_project_details?.mantra_project_code}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {item.mantra_project_details?.mantra_project_name}
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table> :
                                                    <div className="justify-center">
                                                        - No Project Referenced -
                                                    </div>
                                                }
                                            </td> */}
                                            <td className="table-body">
                                                {item.mantra_project_details?.mantra_project_id ? (
                                                    // Priority 1: Mantra project exists
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right  word-wrap-10vw">
                                                                    {item.mantra_project_details?.mantra_project_code}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right word-wrap-15vw">
                                                                    {item.mantra_project_details?.mantra_project_name}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                ) : item.project_id ? (
                                                    // Priority 2: Fallback to ref project
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right word-wrap-10vw">
                                                                    {item.ref_project_code}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right word-wrap-15vw">
                                                                    {item.ref_project_name}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    // Priority 3: No project at all
                                                    <div className="justify-center">
                                                        - No Project Referenced -
                                                    </div>
                                                )}
                                            </td>
                                            <td className="table-body">
                                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                    <tbody>
                                                        {/* <tr>
                                                            <td className="table-body" style={{ paddingBottom: "" }}>Imprest Name</td>
                                                            <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right word-wrap-10vw">
                                                                {item.mantra_project_details?.mantra_project_code}-{item.mantra_project_details?.mantra_project_name}
                                                            </td>
                                                        </tr> */}
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "" }}>Imprest Name</td>
                                                            <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right word-wrap-10vw">
                                                                {item.mantra_project_details?.mantra_project_id
                                                                    ? `${item.mantra_project_details?.mantra_project_code}-${item.mantra_project_details?.mantra_project_name}`
                                                                    : `${item.project_name}`}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "" }}>Imprest Date</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {formatDate(item.date)}
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </td>
                                            {item.rh_leave_status === "approved" ?
                                                <td className="table-body">
                                                    <td className="align-right">
                                                        {/* <b> */}
                                                        {formatCurrencyIndian(
                                                            Number(item.approved_transportation) +
                                                            Number(item.approved_accomodation) +
                                                            Number(item.approved_fooding) +
                                                            (item.other_details?.length > 0
                                                                ? item.other_details.reduce(
                                                                    (total, other) =>
                                                                        total + Number(other.approved_other || 0),
                                                                    0
                                                                )
                                                                : 0)
                                                        )}
                                                        {" "}
                                                        Rs.
                                                        {/* </b> */}
                                                    </td>
                                                </td>
                                                :
                                                <td className="table-body">
                                                    <td className="align-right">
                                                        {/* <b> */}
                                                        {formatCurrencyIndian(
                                                            Number(item.transportation) +
                                                            Number(item.accomodation) +
                                                            Number(item.fooding) +
                                                            (item.other_details?.length > 0
                                                                ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                                                                : 0)
                                                        )}
                                                        {" "}
                                                        Rs.
                                                        {/* </b>  */}
                                                    </td>
                                                </td>}
                                            <td className="table-body">
                                                {item.account_update_datetime ? <>At: {formatDateTime(item.account_update_datetime).date}</> : null}</td>
                                            <td title="Imprest Approval Status" className="table-body width-10vw">
                                                <span
                                                    request-status={item.rh_leave_status}
                                                    className="request-status "
                                                >
                                                    {item.rh_leave_status === "approved" ?
                                                        <>
                                                            Rh ({item.rh_assigned}-{item.rh_assigned_name}) Approved
                                                            {item.rh_update_datetime ? <><br />At: {formatDateTime(item.rh_update_datetime).date}</> : ''}
                                                        </>
                                                        : item.rh_leave_status === "rejected"
                                                            ? <>Rh ✖,<br />Rh Reject Reason:<br />"{item.rejection_reason}"</>
                                                            : "Pending For Rh Approval ⌛"}
                                                </span>
                                                {/* <br /> */}
                                                <br />
                                                <span
                                                    request-status={item.admin_leave_status}
                                                    className="request-status "
                                                >
                                                    {item.admin_leave_status === "approved" ?
                                                        <>
                                                            Admin {item.admin_update_by ? `(${item.admin_update_by}-${item.admin_update_by_name})` : ''} Approved
                                                            {item.admin_update_datetime ? <><br />At: {formatDateTime(item.admin_update_datetime).date}</> : ''}
                                                        </>
                                                        : item.admin_leave_status === "rejected"
                                                            ? <>Admin ✖,<br />Admin Reject Reason: "{item.admin_rejection_reason}"</>
                                                            : "Pending For Admin Approval ⌛"}
                                                </span>
                                                {/* <br /> */}
                                                <br />
                                                <span
                                                    request-status={item.account_leave_status}
                                                    className="request-status "
                                                >
                                                    {item.account_leave_status === "approved" ?
                                                        <>
                                                            Accounts{item.account_update_by ? `(${item.account_update_by}-${item.account_update_by_name})` : ''} Approved
                                                            {item.account_update_datetime ? <><br />At: {formatDateTime(item.account_update_datetime).date}</> : ''}
                                                        </>
                                                        : item.account_leave_status === "rejected"
                                                            ? <>Accounts ✖,<br />Accounts Reject Reason:<br />"{item.account_rejection_reason}"</>
                                                            : "Pending For Account Approval ⌛"}
                                                </span>
                                            </td>
                                            {
                                                item.expense_data.length > 0 ?
                                                    <>
                                                        <td className="table-body">
                                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Expense Name</td>
                                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right">
                                                                            {item.expense_data[0]?.name}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Expense Date</td>
                                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right">
                                                                            {formatDate(item.expense_data[0]?.date)}
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td className="table-body align-center">{item.expense_data[0]?.utilized_amount ? formatRoundoff2D(item.expense_data[0]?.utilized_amount) : '-'} Rs</td>
                                                        {/* {
                                                        item.submit_for_approval === false ?
                                                            <td className="table-body align-center">
                                                                <span
                                                                    request-status={"pending"}
                                                                    className="request-status"
                                                                >
                                                                    Expense Not Submitted
                                                                </span>
                                                            </td>
                                                            :
                                                            <td className="table-body">
                                                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Utilized Bills</td>
                                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                                            <td className="align-right">
                                                                                {item.utilized_amount ? formatRoundoff2D(item.expense_data[0]?.utilized_amount) : '-'} Rs
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Remaining Balance</td>
                                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                                            <td className="align-right">
                                                                                {item.remaining_amount ? formatRoundoff2D(item.expense_data[0]?.remaining_amount) : '-'} Rs
                                                                            </td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                    } */}
                                                        <td className="table-body">{FirstBillDate} to {LastBillDate}</td>
                                                        <td title="Expense Approval Status" className="table-body">
                                                            <span
                                                                request-status={item.expense_data[0]?.rh_status}
                                                                className="request-status"
                                                            >
                                                                {item.expense_data[0]?.rh_status === "pending"
                                                                    ? "Pending For Rh Approval ⌛"
                                                                    : item.expense_data[0]?.rh_status === "rejected"
                                                                        ? `Rh Reject Reason : ${item.expense_data[0]?.rh_rejection_reason}`
                                                                        : `Rh${item.expense_data[0]?.rh_assigned ? `(${item.expense_data[0]?.rh_assigned} - ${item.expense_data[0]?.rh_assigned_name}) ` : ''}: Verified Amounts for Bills ${item.expense_data[0]?.rh_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.rh_update_datetime).date}` : ''}`
                                                                }
                                                            </span>

                                                            <br />
                                                            <span
                                                                request-status={item.expense_data[0]?.account_status_a}
                                                                className="request-status "
                                                            >
                                                                {item.expense_data[0]?.account_status_a === "pending"
                                                                    ? "Pending For Account Approval ⌛"
                                                                    : item.expense_data[0]?.account_status_a === "rejected"
                                                                        ? `Accounts Reject Reason : ${item.expense_data[0]?.account1_rejection_reason}`
                                                                        : `Accounts${item.expense_data[0]?.account_update_by ? `(${item.expense_data[0]?.account_update_by}-${item.expense_data[0]?.account_update_by_name}) ` : ''}: Bills Verified ${item.expense_data[0]?.account_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.account_update_datetime).date}` : ''}`}
                                                            </span>
                                                            <br />
                                                            <span
                                                                request-status={item.expense_data[0]?.admin_status}
                                                                className="request-status "
                                                                title={item.expense_data[0]?.admin_status === "rejected" ? `Admin Reject Reason : ${item.expense_data[0]?.admin_rejection_reason}` : ""}
                                                            >
                                                                {item.expense_data[0]?.admin_status === "pending"
                                                                    ? "Pending For Admin Approval ⌛"
                                                                    : item.expense_data[0]?.admin_status === "rejected"
                                                                        ? `Admin Rejection Reason : ${item.expense_data[0]?.admin_rejection_reason}`
                                                                        : `Admin${item.expense_data[0]?.admin_update_by ? `(${item.expense_data[0]?.admin_update_by}-${item.expense_data[0]?.admin_update_by_name}) ` : ''}: Approved After Final Verification  ${item.expense_data[0]?.admin_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.admin_update_datetime).date}` : ''}`}
                                                            </span>
                                                            <br />
                                                            <span
                                                                request-status={item.expense_data[0]?.account_status_b}
                                                                className="request-status "
                                                            >
                                                                {item.expense_data[0]?.account_status_b === "pending"
                                                                    ? "Final Stage Pending⌛"
                                                                    : item.expense_data[0]?.account_status_b === "rejected"
                                                                        ? `Final Rejection Reason : ${item.expense_data[0]?.account2_rejection_reason}`
                                                                        : `Final${item.expense_data[0]?.final_update_by ? `(${item.expense_data[0]?.final_update_by}-${item.expense_data[0]?.final_update_by_name}) ` : ''}: Approved And Settled ${item.expense_data[0]?.final_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.final_update_datetime).date}` : ''}`}
                                                            </span>
                                                        </td>
                                                    </> :
                                                    <td colSpan={4} className="table-body align-center">- No Expense Details Updated Yet -</td>

                                            }

                                        </tr>
                                    </>
                                )
                            })
                        )}
                    </tbody>
                </table>
            </div>
        </div >
    );
};


// const ImprestExpenseDashboard = () => {

//     const location = useLocation();
//     let filters_employee = location.state?.filter_employee !== null ? location.state?.filter_employee : 'null';
//     let filters_department = location.state?.filter_department !== null ? location.state?.filter_department : `${sessionStorage.getItem("department")}`;
//     let filters_subCompany = location.state?.filter_subCompany !== null ? location.state?.filter_subCompany : `${sessionStorage.getItem("company_id")}`;
//     let filters_empstatus = location.state?.filter_empstatus !== null ? location.state?.filter_empstatus : 'active';


//     const [imprestDateSorting, setImprestDateSorting] = useState("null");
//     const [imprestAmountSorting, setImprestAmountSorting] = useState("null");
//     const [expenseDateSorting, setExpenseDateSorting] = useState("null");
//     const [expenseAmountSorting, setExpenseAmountSorting] = useState("null");

//     const [selectedEmployee, setSelectedEmployee] = useState(sessionStorage.getItem('emp_code'));
//     const [selectedProject, setSelectedProject] = useState('');
//     const [employeeGet, setEmployeeGet] = useState(filters_employee || 'null');
//     const [selectedDepartment, setSelectedDepartment] = useState(filters_department || 'null');
//     const [selectedSubCompany, setSubCompany] = useState(filters_subCompany || `${sessionStorage.getItem("company_id")}`);
//     const [active, setActive] = useState(filters_empstatus || 'active');



//     const [dates, setDates] = useState(0)
//     // setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [buffer1, setBuffering1] = useState(true); //buffering logic
//     const [imprestExpenseData, setImprestExpenseData] = useState([]);
//     const [filteredImprestExpenseData, setfilteredImprestExpenseData] = useState([]);

//     const getImprestExpenseData = async () => {
//         setBuffering(true); //buffering logic // Start Buffering
//         try {
//             // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/imprestexpenseadmindashboard/${employeeGet}/${selectedDepartment}/${selectedSubCompany}/${active}/`
//             );

//             // setImprestExpenseData(res.data);

//             let filteredData = res.data;


//             // Sorting logic for Imprest
//             switch (imprestDateSorting) {
//                 case "asc_date":
//                     filteredData = filteredData.sort((a, b) => new Date(a.date) - new Date(b.date));
//                     break;
//                 case "desc_date":
//                     filteredData = filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
//                     break;
//                 case "asc_bill":
//                     filteredData = filteredData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
//                     break;
//                 case "desc_bill":
//                     filteredData = filteredData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
//                     break;
//                 default:
//                     filteredData = filteredData
//                     break;
//             }

//             // Sorting logic for Imprest Amount
//             switch (imprestAmountSorting) {
//                 case "asc_amount":
//                     filteredData = filteredData.sort((a, b) => {
//                         const amountA = calculateTotalAmount(a);
//                         const amountB = calculateTotalAmount(b);
//                         return amountA - amountB; // Ascending order
//                     });
//                     break;
//                 case "desc_amount":
//                     filteredData = filteredData.sort((a, b) => {
//                         const amountA = calculateTotalAmount(a);
//                         const amountB = calculateTotalAmount(b);
//                         return amountB - amountA; // Descending order
//                     });
//                     break;
//                 default:
//                     filteredData = filteredData
//                     break;
//             }

//             // Sorting logic for Expense
//             switch (expenseDateSorting) {
//                 case "asc_date":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
//                         const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
//                         return aDate - bDate;
//                     });
//                     break;
//                 case "desc_date":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
//                         const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
//                         return bDate - aDate;
//                     });
//                     break;
//                 case "asc_bill":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//                         const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//                         const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
//                         const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
//                         return aFirstDate - bFirstDate;
//                     });
//                     break;
//                 case "desc_bill":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//                         const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//                         const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
//                         const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
//                         return bFirstDate - aFirstDate;
//                     });
//                     break;
//                 case "asc_settlement":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
//                         const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
//                         return aDate - bDate;
//                     });
//                     break;
//                 case "desc_settlement":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
//                         const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
//                         return bDate - aDate;
//                     });
//                     break;
//                 default:
//                     filteredData = filteredData;
//                     break;
//             }
//             // Sorting logic for Imprest Amount
//             switch (expenseAmountSorting) {
//                 case "asc_amount":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
//                         const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
//                         return aAmount - bAmount;
//                     });
//                     break;
//                 case "desc_amount":
//                     filteredData = filteredData.sort((a, b) => {
//                         const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
//                         const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
//                         return bAmount - aAmount;
//                     });
//                     break;
//                 default:
//                     filteredData = filteredData
//                     break;
//             }

//             setImprestExpenseData(filteredData);
//             setfilteredImprestExpenseData(filteredData);
//             // setImprestExpenseData(res.data);

//         } catch (err) {
//             handleAllError(err);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         getImprestExpenseData();
//     }, [employeeGet, selectedDepartment, selectedSubCompany, active, selectedDepartment,
//         imprestDateSorting, imprestAmountSorting, expenseDateSorting, expenseAmountSorting]);


//     const [allemployee, setAllemployee] = useState([]);
//     const [departmentLists, setDepartmentLists] = useState([]);
//     const getFilterData = async () => {
//         setBuffering1(true); //buffering logic // Start Buffering
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`
//             );
//             const sortedList = customSortByKey(res.data, "emp_code");
//             setAllemployee(sortedList);
//             const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem('company_id') || 'null'}/active/`);
//             setDepartmentLists(dep.data);
//         } catch (err) {
//             handleAllError(err);
//         } finally {
//             setBuffering1(false); //buffering logic // End Buffering
//         }
//     };

//     useEffect(() => {
//         getFilterData();
//     }, [active, selectedSubCompany]);

//     const options = allemployee
//         .sort((a, b) => a.emp_code - b.emp_code)
//         .map((i) => ({
//             value: i.emp_code,
//             label: `${i.emp_code} - ${i.name}`,
//         }));

//     const nullOption = { value: 'null', label: 'Select Employee Code' };

//     const handleChange = (selectedOption) => {
//         if (selectedOption) {
//             // Set selected employee code(s)
//             setEmployeeGet(selectedOption.value);
//         } else {
//             setEmployeeGet(null); // Clear selection
//         }
//     };
//     const handleImprestDateSortChange = (e) => setImprestDateSorting(e.target.value);
//     const handleImprestAmountSortChange = (e) => setImprestAmountSorting(e.target.value);
//     const handleExpenseDateSortChange = (e) => setExpenseDateSorting(e.target.value);
//     const handleExpenseAmountSortChange = (e) => setExpenseAmountSorting(e.target.value);


//     const applyFilters = () => {
//         let filteredData = imprestExpenseData;

//         if (selectedProject !== '') {
//             const lowercaseSelectedProject = selectedProject.toLowerCase();
//             filteredData = filteredData.filter((data) => {
//                 const nameMatch = data.ref_project_name?.toLowerCase().includes(lowercaseSelectedProject);
//                 const codeMatch = data.ref_project_code?.toString().includes(selectedProject);
//                 return nameMatch || codeMatch;
//             });
//         }
//         // // Sorting logic for Imprest
//         // switch (imprestDateSorting) {
//         //     case "asc_date":
//         //         filteredData = filteredData.sort((a, b) => new Date(a.date) - new Date(b.date));
//         //         break;
//         //     case "desc_date":
//         //         filteredData = filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
//         //         break;
//         //     case "asc_bill":
//         //         filteredData = filteredData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
//         //         break;
//         //     case "desc_bill":
//         //         filteredData = filteredData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
//         //         break;
//         //     default:
//         //         filteredData = filteredData
//         //         break;
//         // }

//         // // Sorting logic for Imprest Amount
//         // switch (imprestAmountSorting) {
//         //     case "asc_amount":
//         //         filteredData = filteredData.sort((a, b) => {
//         //             const amountA = calculateTotalAmount(a);
//         //             const amountB = calculateTotalAmount(b);
//         //             return amountA - amountB; // Ascending order
//         //         });
//         //         break;
//         //     case "desc_amount":
//         //         filteredData = filteredData.sort((a, b) => {
//         //             const amountA = calculateTotalAmount(a);
//         //             const amountB = calculateTotalAmount(b);
//         //             return amountB - amountA; // Descending order
//         //         });
//         //         break;
//         //     default:
//         //         filteredData = filteredData
//         //         break;
//         // }

//         // // Sorting logic for Expense
//         // switch (expenseDateSorting) {
//         //     case "asc_date":
//         //         filteredData = filteredData.sort((a, b) => new Date(a.expense_data?.[0]?.date) - new Date(b.expense_data?.[0]?.date));
//         //         break;
//         //     case "desc_date":
//         //         filteredData = filteredData.sort((a, b) => new Date(b.expense_data?.[0]?.date) - new Date(a.expense_data?.[0]?.date));
//         //         break;
//         //     case "asc_bill":
//         //         filteredData = filteredData.sort((a, b) => {
//         //             const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//         //             const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//         //             const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
//         //             const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
//         //             return aFirstDate - bFirstDate;
//         //         });
//         //         break;
//         //     case "desc_bill":
//         //         filteredData = filteredData.sort((a, b) => {
//         //             const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//         //             const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
//         //             const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
//         //             const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
//         //             return bFirstDate - aFirstDate;
//         //         });
//         //         break;
//         //     case "asc_settlement":
//         //         filteredData = filteredData.sort((a, b) => new Date(a.expense_data?.[0]?.final_update_datetime) - new Date(b.expense_data?.[0]?.final_update_datetime));

//         //         break;
//         //     case "desc_settlement":
//         //         filteredData = filteredData.sort((a, b) => new Date(b.expense_data?.[0]?.final_update_datetime) - new Date(a.expense_data?.[0]?.final_update_datetime));
//         //         break;
//         //     default:
//         //         filteredData = filteredData
//         //         break;
//         // }

//         // // Sorting logic for Imprest Amount
//         // switch (expenseAmountSorting) {
//         //     case "asc_amount":
//         //         filteredData = filteredData.sort((a, b) => {
//         //             const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
//         //             const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
//         //             return aAmount - bAmount;
//         //         });
//         //         break;
//         //     case "desc_amount":
//         //         filteredData = filteredData.sort((a, b) => {
//         //             const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
//         //             const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
//         //             return bAmount - aAmount;
//         //         });
//         //         break;
//         //     default:
//         //         filteredData = filteredData
//         //         break;
//         // }

//         // Update the filtered data state
//         setfilteredImprestExpenseData(filteredData);
//     };

//     // Helper function to calculate the total amount for an item
//     const calculateTotalAmount = (item) => {
//         if (item.rh_leave_status === "approved") {
//             return (
//                 Number(item.approved_transportation) +
//                 Number(item.approved_accomodation) +
//                 Number(item.approved_fooding) +
//                 (item.other_details?.length > 0
//                     ? item.other_details.reduce(
//                         (total, other) => total + Number(other.approved_other || 0),
//                         0
//                     )
//                     : 0)
//             );
//         } else {
//             return (
//                 Number(item.transportation) +
//                 Number(item.accomodation) +
//                 Number(item.fooding) +
//                 (item.other_details?.length > 0
//                     ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
//                     : 0)
//             );
//         }
//     };

//     useEffect(() => {
//         applyFilters();
//     }, [imprestExpenseData, selectedProject]);

//     const tableRef = useRef(null);

//     return (
//         <div className="attendance-history-cont">
//             <div className="attendance-subcont">
//                 <div className="field-cont">
//                     <div className="field-cont-div">
//                         {/* <Employee /> */}
//                         {buffer1 ?
//                             <div className="align-center form-loader">
//                                 <div className="bar-loader"></div>
//                             </div>
//                             :
//                             <>
//                                 <Employee />
//                                 <Select
//                                     className="attendance-input-field width-20vw"
//                                     width="200px"
//                                     options={[nullOption, ...options]} // Include "null" option at the beginning
//                                     value={options.find(option => option.value === employeeGet) || nullOption}  // Ensure the correct option is selected
//                                     placeholder="Select Employee Code"
//                                     onChange={handleChange}
//                                     isClearable
//                                     styles={{
//                                         control: (provided) => ({
//                                             ...provided,
//                                             color: '#707070',
//                                             outline: 'none',
//                                             border: 'none',
//                                             padding: '0.6rem 0.5rem',
//                                             textTransform: 'capitalize',
//                                             boxShadow: 'none',
//                                             '&:hover': {
//                                                 border: 'none',
//                                             },
//                                         }),
//                                         singleValue: (provided) => ({
//                                             ...provided,
//                                             color: '#707070',
//                                         }),
//                                         placeholder: (provided) => ({
//                                             ...provided,
//                                             color: '#707070',
//                                         }),
//                                         dropdownIndicator: (provided) => ({
//                                             ...provided,
//                                             filter: 'invert(50%)',
//                                             cursor: 'pointer',
//                                             left: '9.5rem',
//                                             width: '20px',
//                                             height: '20px',
//                                         }),
//                                         menu: (provided) => ({
//                                             ...provided,
//                                             zIndex: 9999, // Ensure dropdown menu appears above other elements
//                                         }),
//                                         option: (provided, state) => ({
//                                             ...provided,
//                                             color: state.isSelected ? '#2576bc' : '#707070',
//                                             backgroundColor: state.isSelected ? 'rgba(37,118,188,0.1)' : 'white',
//                                             cursor: 'pointer',
//                                             '&:hover': {
//                                                 backgroundColor: '#2576bc',
//                                                 color: 'white',
//                                             },
//                                         }),
//                                     }}
//                                 />
//                             </>}
//                         <hr className="field-cont-hr" />
//                     </div>

//                     <div className="field-cont-div">
//                         {/* <Project /> */}
//                         {buffer ?
//                             <div className="align-center justify-center">
//                                 <div className=" form-loader">
//                                     <div className="bar-loader"></div>
//                                 </div>
//                             </div>
//                             :
//                             <>
//                                 <div className="field-cont-div-svg">
//                                     <SearchBig />
//                                     <input
//                                         className="attendance-input-field width-15vw  "
//                                         placeholder="By Project Code, Name"
//                                         type="text"
//                                         value={selectedProject}
//                                         onChange={(e) => setSelectedProject(e.target.value)}
//                                     />
//                                 </div>
//                             </>}
//                         <hr className="field-cont-hr" />
//                     </div>

//                     <div className="field-cont-div">
//                         {buffer1 ?
//                             <div className="align-center form-loader">
//                                 <div className="bar-loader"></div>
//                             </div>
//                             :
//                             <>
//                                 <CircularGrid />
//                                 <select
//                                     className="attendance-input-field width-15vw   date-field"
//                                     type="text"
//                                     value={selectedDepartment}
//                                     onChange={(e) => setSelectedDepartment(e.target.value)}
//                                 >
//                                     <option value="null">All Department</option>
//                                     {departmentLists
//                                         .sort((a, b) => a.title - b.title)
//                                         .map((i, index) => (
//                                             <option value={i.id}>{i.title}</option>
//                                         ))};
//                                 </select>
//                             </>}
//                         <hr className="field-cont-hr" />
//                     </div>
//                     <div title="Sort Filter" className="field-cont-div">
//                         <Sort />
//                         <select
//                             className="attendance-input-field width-15vw   date-field"
//                             type="text"
//                             value={imprestDateSorting}
//                             onChange={handleImprestDateSortChange}
//                         >
//                             <option value="null">No Imprest Filter</option>
//                             <option value="asc_date">Asc. Imprest Date</option>
//                             <option value="desc_date">Desc. Imprest Date</option>
//                             <option value="asc_bill">Asc. Imprest Settlement</option>
//                             <option value="desc_bill">Desc. Imprest Settlement</option>
//                         </select>
//                         <hr className="field-cont-hr" />
//                     </div>
//                     <div title="Sort Filter" className="field-cont-div">
//                         <Sort />
//                         <select
//                             className="attendance-input-field width-15vw   date-field"
//                             type="text"
//                             value={imprestAmountSorting}
//                             onChange={handleImprestAmountSortChange}
//                         >
//                             <option value="null">No Imprest Amount Filter</option>
//                             <option value="asc_amount">Asc. Imprest Amount</option>
//                             <option value="desc_amount">Desc. Imprest Amount</option>
//                         </select>
//                         <hr className="field-cont-hr" />
//                     </div>
//                     <div title="Sort Filter" className="field-cont-div">
//                         <Sort />
//                         <select
//                             className="attendance-input-field width-15vw   date-field"
//                             type="text"
//                             value={expenseDateSorting}
//                             onChange={handleExpenseDateSortChange}
//                         >
//                             <option value="null">No Expense Date Filter</option>
//                             <option value="asc_date">Asc. Expense Date</option>
//                             <option value="desc_date">Desc. Expense Date</option>
//                             <option value="asc_bill">Asc. Expense Bills</option>
//                             <option value="desc_bill">Desc. Expense Bills</option>
//                             <option value="asc_settlement">Asc. Expense Settlement</option>
//                             <option value="desc_settlement">Desc. Expense Settlement</option>
//                         </select>
//                         <hr className="field-cont-hr" />
//                     </div>
//                     <div title="Sort Filter" className="field-cont-div">
//                         <Sort />
//                         <select
//                             className="attendance-input-field width-15vw   date-field"
//                             type="text"
//                             value={expenseAmountSorting}
//                             onChange={handleExpenseAmountSortChange}
//                         >
//                             <option value="null">No Expense Amount Filter</option>
//                             <option value="asc_amount">Asc. Expense Amount</option>
//                             <option value="desc_amount">Desc. Expense Amount</option>
//                         </select>
//                         <hr className="field-cont-hr" />
//                     </div>

//                 </div>
//                 <div className="btn-cont">
//                     {/* <hr className="field-cont-hr" /> */}
//                     {
//                         buffer ? <div className="spinner-small"></div> :
//                             <DownloadTableExcel
//                                 // filename={`Expense Data ${fromdate === todate ? `${fromdate}` : `${fromdate} to ${todate}`} ${datetimefield}`}
//                                 filename={`Imprest Expense DataSheet`}
//                                 sheet="Details"
//                                 currentTableRef={tableRef.current}
//                             >
//                                 <button className="model-button   font-weight500   model-button-print">
//                                     <DownloadIcon />
//                                 </button>
//                             </DownloadTableExcel>}

//                 </div>
//             </div>

//             <div className="table-css-white-background-new scroll-container-table">
//                 <table ref={tableRef} className="">
//                     <thead
//                         style={{
//                             position: "sticky",
//                             top: "0",
//                             backgroundColor: "#fff",
//                             zIndex: "10",
//                         }}
//                     >
//                         <tr className="custom-table-head-tr-0P">
//                             <th className="table-heading">S. No.</th>
//                             <th className="table-heading">Employee Details</th>
//                             <th className="table-heading">Project Reference</th>
//                             <th className="table-heading text-center">Imprest Details</th>
//                             <th className="table-heading">Imprest Amount</th>
//                             <th className="table-heading">Imprest Received Date</th>
//                             <th className="table-heading">Imprest Approval Status</th>
//                             <th className="table-heading">Expense Details</th>
//                             <th className="table-heading">Expense Amount</th>
//                             <th className="table-heading">Expense Bills Date Range</th>
//                             <th className="table-heading">Expense Approval Status</th>
//                         </tr>
//                     </thead>
//                     {buffer ? <div className="spinner"></div> : //buffering logic
//                         <tbody>
//                             {filteredImprestExpenseData
//                                 ?.map((item, index) => {
//                                     const expenseData = item?.expense_data?.length > 0 ? item.expense_data[0] : null;

//                                     // Check if expense details exist before mapping
//                                     const DatesList = expenseData?.expense_details?.length > 0
//                                         ? expenseData.expense_details.map(exp => exp.date).sort((a, b) => new Date(a) - new Date(b))
//                                         : [];

//                                     const FirstBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[0]);
//                                     const LastBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[DatesList.length - 1]);

//                                     // console.log("DatesList")
//                                     // console.log(DatesList)
//                                     return (
//                                         <>
//                                             <tr className="custom-table-head-td" key={index}>
//                                                 <td className="table-body">{index + 1}</td>
//                                                 <td className="table-body" style={{ textAlign: "center" }}>
//                                                     <CustomImageModal customStyle>
//                                                         {item?.profilepic ? (
//                                                             <img
//                                                                 src={`${IMAGE_URL}${item.profilepic}`}
//                                                                 alt="profile" className="profile-img"
//                                                             />
//                                                         ) : (
//                                                             <UserDefaultLogo user={{ name: item.emp_name, profilepic: item.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
//                                                         )}
//                                                     </CustomImageModal>
//                                                     <p>{item.empcode}-{item.emp_name}</p>
//                                                 </td>
//                                                 {/* <td className="table-body">
//                                                     {item.mantra_project_details?.mantra_project_id ?
//                                                         <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                             <tbody>
//                                                                 <tr>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>Project Code</td>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                     <td className="align-right word-wrap-20vw">
//                                                                         {item.mantra_project_details?.mantra_project_code}
//                                                                     </td>
//                                                                 </tr>
//                                                                 <tr>
//                                                                     <td className="table-body" >Project Name</td>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                     <td className="align-right word-wrap-20vw">
//                                                                         {item.mantra_project_details?.mantra_project_name}
//                                                                     </td>
//                                                                 </tr>

//                                                             </tbody>
//                                                         </table> :
//                                                         <div className="align-center justify-center">
//                                                             - No Project Referenced -
//                                                         </div>
//                                                     }
//                                                 </td> */}
//                                                 <td className="table-body">
//                                                     {item?.mantra_project_details?.mantra_project_id ? (
//                                                         // Priority 1: Mantra project exists
//                                                         <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                             <tbody>
//                                                                 <tr>
//                                                                     <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                     <td className="align-right word-wrap-10vw">
//                                                                         {item?.mantra_project_details?.mantra_project_code}
//                                                                     </td>
//                                                                 </tr>
//                                                                 <tr>
//                                                                     <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                     <td className="align-right  word-wrap-15vw">
//                                                                         {item?.mantra_project_details?.mantra_project_name}
//                                                                     </td>
//                                                                 </tr>
//                                                             </tbody>
//                                                         </table>
//                                                     ) : item?.project_id ? (
//                                                         // Priority 2: Fallback to ref project
//                                                         <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                             <tbody>
//                                                                 <tr>
//                                                                     <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                     <td className="align-right  word-wrap-10vw">
//                                                                         {item?.ref_project_code}
//                                                                     </td>
//                                                                 </tr>
//                                                                 <tr>
//                                                                     <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
//                                                                     <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                     <td className="align-right word-wrap-15vw">
//                                                                         {item?.ref_project_name}
//                                                                     </td>
//                                                                 </tr>
//                                                             </tbody>
//                                                         </table>
//                                                     ) : (
//                                                         // Priority 3: No project at all
//                                                         <div className="justify-center">
//                                                             - No Project Referenced -
//                                                         </div>
//                                                     )}
//                                                 </td>
//                                                 <td className="table-body">
//                                                     <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                         <tbody>
//                                                             <tr>
//                                                                 <td className="table-body" >Imprest Name</td>
//                                                                 <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="align-right word-wrap-10vw">
//                                                                     {item?.mantra_project_details?.mantra_project_id
//                                                                         ? `${item?.mantra_project_details?.mantra_project_code}-${item?.mantra_project_details?.mantra_project_name}`
//                                                                         : `${item.project_name}`}
//                                                                     {/* {item.mantra_project_details?.mantra_project_code}-{item.mantra_project_details?.mantra_project_name} */}
//                                                                 </td>
//                                                             </tr>
//                                                             <tr>
//                                                                 <td className="table-body" style={{ paddingBottom: "" }}>Imprest Date</td>
//                                                                 <td style={{ padding: "0px 4px" }}>:</td>
//                                                                 <td className="align-right">
//                                                                     {formatDate(item.date)}
//                                                                 </td>
//                                                             </tr>

//                                                         </tbody>
//                                                     </table>
//                                                 </td>
//                                                 {item.rh_leave_status === "approved" ?
//                                                     <td className="table-body">
//                                                         <td className="align-right">
//                                                             {/* <b> */}
//                                                             {formatCurrencyIndian(
//                                                                 Number(item.approved_transportation) +
//                                                                 Number(item.approved_accomodation) +
//                                                                 Number(item.approved_fooding) +
//                                                                 (item.other_details?.length > 0
//                                                                     ? item.other_details.reduce(
//                                                                         (total, other) =>
//                                                                             total + Number(other.approved_other || 0),
//                                                                         0
//                                                                     )
//                                                                     : 0)
//                                                             )}
//                                                             {" "}
//                                                             Rs.
//                                                             {/* </b> */}
//                                                         </td>
//                                                     </td>
//                                                     :
//                                                     <td className="table-body">
//                                                         <td className="align-right">
//                                                             {/* <b> */}
//                                                             {formatCurrencyIndian(
//                                                                 Number(item.transportation) +
//                                                                 Number(item.accomodation) +
//                                                                 Number(item.fooding) +
//                                                                 (item.other_details?.length > 0
//                                                                     ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
//                                                                     : 0)
//                                                             )}
//                                                             {" "}
//                                                             Rs.
//                                                             {/* </b>  */}
//                                                         </td>
//                                                     </td>}
//                                                 <td className="table-body">
//                                                     {item.account_update_datetime ? <>At: {(formatDate(item.account_update_datetime))}</> : null}</td>
//                                                 <td title="Imprest Approval Status" className="table-body width-10vw">
//                                                     <span
//                                                         request-status={item.rh_leave_status}
//                                                         className="request-status "
//                                                     >
//                                                         {item.rh_leave_status === "approved" ?
//                                                             <>
//                                                                 Rh ({item.rh_assigned}-{item.rh_assigned_name}) Approved
//                                                                 {item.rh_update_datetime ? <><br />At: {formatDateTime(item.rh_update_datetime).date}</> : ''}
//                                                             </>
//                                                             : item.rh_leave_status === "rejected"
//                                                                 ? <>Rh ✖,<br />Rh Reject Reason:<br />"{item.rejection_reason}"</>
//                                                                 : "Pending For Rh Approval ⌛"}
//                                                     </span>
//                                                     {/* <br /> */}
//                                                     <br />
//                                                     <span
//                                                         request-status={item.admin_leave_status}
//                                                         className="request-status "
//                                                     >
//                                                         {item.admin_leave_status === "approved" ?
//                                                             <>
//                                                                 Admin {item.admin_update_by ? `(${item.admin_update_by}-${item.admin_update_by_name})` : ''} Approved
//                                                                 {item.admin_update_datetime ? <><br />At: {formatDateTime(item.admin_update_datetime).date}</> : ''}
//                                                             </>
//                                                             : item.admin_leave_status === "rejected"
//                                                                 ? <>Admin ✖,<br />Admin Reject Reason: "{item.admin_rejection_reason}"</>
//                                                                 : "Pending For Admin Approval ⌛"}
//                                                     </span>
//                                                     {/* <br /> */}
//                                                     <br />
//                                                     <span
//                                                         request-status={item.account_leave_status}
//                                                         className="request-status "
//                                                     >
//                                                         {item.account_leave_status === "approved" ?
//                                                             <>
//                                                                 Accounts{item.account_update_by ? `(${item.account_update_by}-${item.account_update_by_name})` : ''} Approved
//                                                                 {item.account_update_datetime ? <><br />At: {formatDateTime(item.account_update_datetime).date}</> : ''}
//                                                             </>
//                                                             : item.account_leave_status === "rejected"
//                                                                 ? <>Accounts ✖,<br />Accounts Reject Reason:<br />"{item.account_rejection_reason}"</>
//                                                                 : "Pending For Account Approval ⌛"}
//                                                     </span>
//                                                 </td>
//                                                 {
//                                                     item.expense_data.length > 0 ?
//                                                         <>
//                                                             <td className="table-body">
//                                                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                                     <tbody>
//                                                                         <tr>
//                                                                             <td className="" >Expense Name</td>
//                                                                             <td style={{ padding: "0px 4px" }}>:</td>
//                                                                             <td className="align-right word-wrap-10vw">
//                                                                                 {item.expense_data[0]?.name}
//                                                                             </td>
//                                                                         </tr>
//                                                                         <tr>
//                                                                             <td className="table-body" style={{ paddingBottom: "5px" }}>Expense Date</td>
//                                                                             <td style={{ padding: "0px 4px" }}>:</td>
//                                                                             <td className="align-right">
//                                                                                 {formatDate(item.expense_data[0]?.date)}
//                                                                             </td>
//                                                                         </tr>

//                                                                     </tbody>
//                                                                 </table>
//                                                             </td>
//                                                             <td className="table-body align-center">{item.expense_data[0]?.utilized_amount ? formatRoundoff2D(item.expense_data[0]?.utilized_amount) : '-'} Rs</td>
//                                                             <td className="table-body">{FirstBillDate} to {LastBillDate}</td>
//                                                             <td title="Expense Approval Status" className="table-body">
//                                                                 <span
//                                                                     request-status={item.expense_data[0]?.rh_status}
//                                                                     className="request-status "
//                                                                 >
//                                                                     {item.expense_data[0]?.rh_status === "pending"
//                                                                         ? "Pending For Rh Approval ⌛"
//                                                                         : item.expense_data[0]?.rh_status === "rejected"
//                                                                             ? `Rh Reject Reason : ${item.expense_data[0]?.rh_rejection_reason}`
//                                                                             : `Rh${item.expense_data[0]?.rh_assigned ? `(${item.expense_data[0]?.rh_assigned}-${item.expense_data[0]?.rh_assigned_name}) ` : ''}: Verified Amounts for Bills ${item.expense_data[0]?.rh_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.rh_update_datetime).date}` : ''}`}
//                                                                 </span>
//                                                                 <br />
//                                                                 <span
//                                                                     request-status={item.expense_data[0]?.account_status_a}
//                                                                     className="request-status "
//                                                                 >
//                                                                     {item.expense_data[0]?.account_status_a === "pending"
//                                                                         ? "Pending For Account Approval ⌛"
//                                                                         : item.expense_data[0]?.account_status_a === "rejected"
//                                                                             ? `Accounts Reject Reason : ${item.expense_data[0]?.account1_rejection_reason}`
//                                                                             : `Accounts${item.expense_data[0]?.account_update_by ? `(${item.expense_data[0]?.account_update_by}-${item.expense_data[0]?.account_update_by_name}) ` : ''}: Bills Verified ${item.expense_data[0]?.account_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.account_update_datetime).date}` : ''}`}
//                                                                 </span>
//                                                                 <br />
//                                                                 <span
//                                                                     request-status={item.expense_data[0]?.admin_status}
//                                                                     className="request-status "
//                                                                     title={item.expense_data[0]?.admin_status === "rejected" ? `Admin Reject Reason : ${item.expense_data[0]?.admin_rejection_reason}` : ""}
//                                                                 >
//                                                                     {item.expense_data[0]?.admin_status === "pending"
//                                                                         ? "Pending For Admin Approval ⌛"
//                                                                         : item.expense_data[0]?.admin_status === "rejected"
//                                                                             ? `Admin Rejection Reason : ${item.expense_data[0]?.admin_rejection_reason}`
//                                                                             : `Admin${item.expense_data[0]?.admin_update_by ? `(${item.expense_data[0]?.admin_update_by}-${item.expense_data[0]?.admin_update_by_name}) ` : ''}: Approved After Final Verification  ${item.expense_data[0]?.admin_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.admin_update_datetime).date}` : ''}`}
//                                                                 </span>
//                                                                 <br />
//                                                                 <span
//                                                                     request-status={item.expense_data[0]?.account_status_b}
//                                                                     className="request-status "
//                                                                 >
//                                                                     {item.expense_data[0]?.account_status_b === "pending"
//                                                                         ? "Final Stage Pending⌛"
//                                                                         : item.expense_data[0]?.account_status_b === "rejected"
//                                                                             ? `Final Rejection Reason : ${item.expense_data[0]?.account2_rejection_reason}`
//                                                                             : `Final${item.expense_data[0]?.final_update_by ? `(${item.expense_data[0]?.final_update_by}-${item.expense_data[0]?.final_update_by_name}) ` : ''}: Approved And Settled ${item.expense_data[0]?.final_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.final_update_datetime).date}` : ''}`}
//                                                                 </span>
//                                                             </td>
//                                                         </> :
//                                                         <td colSpan={4} className="table-body align-center">- No Expense Details Updated Yet -</td>

//                                                 }
//                                             </tr>
//                                         </>
//                                     )
//                                 }
//                                 )}
//                         </tbody>
//                     }
//                 </table>
//             </div>
//         </div>
//     );
// };

const ImprestExpenseDashboard = () => {

    const location = useLocation();
    let filters_employee = location.state?.filter_employee !== null ? location.state?.filter_employee : 'null';
    let filters_department = location.state?.filter_department !== null ? location.state?.filter_department : `${sessionStorage.getItem("department")}`;
    let filters_subCompany = location.state?.filter_subCompany !== null ? location.state?.filter_subCompany : `${sessionStorage.getItem("company_id")}`;
    let filters_empstatus = location.state?.filter_empstatus !== null ? location.state?.filter_empstatus : 'active';
    let filters_fromdate = location.state?.filter_fromdate != null ? location.state?.filter_fromdate : defaultFromDate;
    let filters_todate = location.state?.filter_todate != null ? location.state?.filter_todate : defaultToDate;


    const [imprestDateSorting, setImprestDateSorting] = useState("null");
    const [imprestAmountSorting, setImprestAmountSorting] = useState("null");
    const [expenseDateSorting, setExpenseDateSorting] = useState("null");
    const [expenseAmountSorting, setExpenseAmountSorting] = useState("null");
    const [selectedEmployee, setSelectedEmployee] = useState(sessionStorage.getItem('emp_code'));
    const [selectedProject, setSelectedProject] = useState('');
    const [employeeGet, setEmployeeGet] = useState(filters_employee || 'null');
    const [selectedDepartment, setSelectedDepartment] = useState(filters_department || 'null');
    const [selectedSubCompany, setSubCompany] = useState(filters_subCompany || `${sessionStorage.getItem("company_id")}`);
    const [active, setActive] = useState(filters_empstatus || 'active');
    const [fromdate, setFromDate] = useState(filters_fromdate || defaultFromDate);
    const [todate, setToDate] = useState(filters_todate || defaultToDate);


    // ================= PAGINATION STATES =================
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const observerTarget = useRef(null);


    const [dates, setDates] = useState(0)
    // setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(true); //buffering logic
    const [imprestExpenseData, setImprestExpenseData] = useState([]);
    const [filteredImprestExpenseData, setfilteredImprestExpenseData] = useState([]);

    // const getImprestExpenseData = async () => {
    //     setBuffering(true); //buffering logic // Start Buffering
    //     try {
    //         // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
    //         const res = await axios.get(
    //             // `${BASE_URL}/wfm/imprestexpenseadmindashboard/${employeeGet}/${selectedDepartment}/${selectedSubCompany}/${active}/`
    //             `${BASE_URL}/wfm/imprestexpenseadmindashboardfast/${employeeGet}/${selectedDepartment}/${selectedSubCompany}/${active}/${fromdate}/${todate}/`
    //         );

    //         // setImprestExpenseData(res.data);

    //         let filteredData = res.data;


    //         // Sorting logic for Imprest
    //         switch (imprestDateSorting) {
    //             case "asc_date":
    //                 filteredData = filteredData.sort((a, b) => new Date(a.date) - new Date(b.date));
    //                 break;
    //             case "desc_date":
    //                 filteredData = filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
    //                 break;
    //             case "asc_bill":
    //                 filteredData = filteredData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
    //                 break;
    //             case "desc_bill":
    //                 filteredData = filteredData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
    //                 break;
    //             default:
    //                 filteredData = filteredData
    //                 break;
    //         }

    //         // Sorting logic for Imprest Amount
    //         switch (imprestAmountSorting) {
    //             case "asc_amount":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const amountA = calculateTotalAmount(a);
    //                     const amountB = calculateTotalAmount(b);
    //                     return amountA - amountB; // Ascending order
    //                 });
    //                 break;
    //             case "desc_amount":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const amountA = calculateTotalAmount(a);
    //                     const amountB = calculateTotalAmount(b);
    //                     return amountB - amountA; // Descending order
    //                 });
    //                 break;
    //             default:
    //                 filteredData = filteredData
    //                 break;
    //         }

    //         // Sorting logic for Expense
    //         switch (expenseDateSorting) {
    //             case "asc_date":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
    //                     const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
    //                     return aDate - bDate;
    //                 });
    //                 break;
    //             case "desc_date":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
    //                     const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
    //                     return bDate - aDate;
    //                 });
    //                 break;
    //             case "asc_bill":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
    //                     const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
    //                     const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
    //                     const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
    //                     return aFirstDate - bFirstDate;
    //                 });
    //                 break;
    //             case "desc_bill":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
    //                     const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
    //                     const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
    //                     const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
    //                     return bFirstDate - aFirstDate;
    //                 });
    //                 break;
    //             case "asc_settlement":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
    //                     const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
    //                     return aDate - bDate;
    //                 });
    //                 break;
    //             case "desc_settlement":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
    //                     const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
    //                     return bDate - aDate;
    //                 });
    //                 break;
    //             default:
    //                 filteredData = filteredData;
    //                 break;
    //         }
    //         // Sorting logic for Imprest Amount
    //         switch (expenseAmountSorting) {
    //             case "asc_amount":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
    //                     const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
    //                     return aAmount - bAmount;
    //                 });
    //                 break;
    //             case "desc_amount":
    //                 filteredData = filteredData.sort((a, b) => {
    //                     const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
    //                     const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
    //                     return bAmount - aAmount;
    //                 });
    //                 break;
    //             default:
    //                 filteredData = filteredData
    //                 break;
    //         }

    //         setImprestExpenseData(filteredData);
    //         setfilteredImprestExpenseData(filteredData);
    //         // setImprestExpenseData(res.data);

    //     } catch (err) {
    //         handleAllError(err);
    //     } finally {
    //         setBuffering(false);// End Buffering
    //     }
    // };

    // ================= API CALL: FETCH & FILTER =================
    const getImprestExpenseData = async (currentPage = 1, forceReset = false) => {
        if (currentPage === 1) {
            setBuffering(true);
        } else {
            setLoadingMore(true);
        }

        try {
            // New endpoint with pagination (no date filters)
            const res = await axios.get(
                `${BASE_URL}/wfm/imprestexpenseadmindashboardfast/${employeeGet}/${selectedDepartment}/${selectedSubCompany}/${active}/?page=${currentPage}&page_size=100`
            );

            const fetchedResults = res.data.results || [];
            setTotalPages(res.data.total_pages || 1);

            // Apply sorting to fetched results
            const sortedResults = applySorting(fetchedResults);

            if (currentPage === 1 || forceReset) {
                setImprestExpenseData(sortedResults);
                setfilteredImprestExpenseData(sortedResults);
            } else {
                setImprestExpenseData((prev) => [...prev, ...sortedResults]);
                setfilteredImprestExpenseData((prev) => [...prev, ...sortedResults]);
            }
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);
            setLoadingMore(false);
        }
    };

    // useEffect(() => {
    //     getImprestExpenseData();
    // }, [employeeGet, selectedDepartment, selectedSubCompany, active, selectedDepartment,
    //     imprestDateSorting, imprestAmountSorting, expenseDateSorting, expenseAmountSorting, fromdate, todate]);

    // ================= FETCH NEXT PAGE =================
    useEffect(() => {
        if (page > 1) {
            getImprestExpenseData(page, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    // ================= RESET PAGE ON FILTER CHANGE =================
    useEffect(() => {
        setPage(1);
        getImprestExpenseData(1, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employeeGet, selectedDepartment, selectedSubCompany, active, imprestDateSorting, imprestAmountSorting, expenseDateSorting, expenseAmountSorting]);

    // ================= INFINITE SCROLL OBSERVER =================
    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (
                target.isIntersecting &&
                !buffer &&
                !loadingMore &&
                page < totalPages
            ) {
                setPage((prevPage) => prevPage + 1);
            }
        },
        [buffer, loadingMore, page, totalPages]
    );

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }
        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [handleObserver]);


    const [allemployee, setAllemployee] = useState([]);
    const [departmentLists, setDepartmentLists] = useState([]);
    const getFilterData = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setAllemployee(sortedList);
            const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem('company_id') || 'null'}/active/`);
            setDepartmentLists(dep.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getFilterData();
    }, [active, selectedSubCompany]);

    const options = allemployee
        .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.emp_code,
            label: `${i.emp_code} - ${i.name}`,
        }));

    const nullOption = { value: 'null', label: 'Select Employee Code' };

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            // Set selected employee code(s)
            setEmployeeGet(selectedOption.value);
        } else {
            setEmployeeGet(null); // Clear selection
        }
    };
    const handleImprestDateSortChange = (e) => setImprestDateSorting(e.target.value);
    const handleImprestAmountSortChange = (e) => setImprestAmountSorting(e.target.value);
    const handleExpenseDateSortChange = (e) => setExpenseDateSorting(e.target.value);
    const handleExpenseAmountSortChange = (e) => setExpenseAmountSorting(e.target.value);


    const applyFilters = () => {
        let filteredData = imprestExpenseData;

        if (selectedProject !== '') {
            const lowercaseSelectedProject = selectedProject.toLowerCase();
            filteredData = filteredData.filter((data) => {
                const nameMatch = data.ref_project_name?.toLowerCase().includes(lowercaseSelectedProject);
                const codeMatch = data.ref_project_code?.toString().includes(selectedProject);
                return nameMatch || codeMatch;
            });
        }
        // // Sorting logic for Imprest
        // switch (imprestDateSorting) {
        //     case "asc_date":
        //         filteredData = filteredData.sort((a, b) => new Date(a.date) - new Date(b.date));
        //         break;
        //     case "desc_date":
        //         filteredData = filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
        //         break;
        //     case "asc_bill":
        //         filteredData = filteredData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
        //         break;
        //     case "desc_bill":
        //         filteredData = filteredData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
        //         break;
        //     default:
        //         filteredData = filteredData
        //         break;
        // }

        // // Sorting logic for Imprest Amount
        // switch (imprestAmountSorting) {
        //     case "asc_amount":
        //         filteredData = filteredData.sort((a, b) => {
        //             const amountA = calculateTotalAmount(a);
        //             const amountB = calculateTotalAmount(b);
        //             return amountA - amountB; // Ascending order
        //         });
        //         break;
        //     case "desc_amount":
        //         filteredData = filteredData.sort((a, b) => {
        //             const amountA = calculateTotalAmount(a);
        //             const amountB = calculateTotalAmount(b);
        //             return amountB - amountA; // Descending order
        //         });
        //         break;
        //     default:
        //         filteredData = filteredData
        //         break;
        // }

        // // Sorting logic for Expense
        // switch (expenseDateSorting) {
        //     case "asc_date":
        //         filteredData = filteredData.sort((a, b) => new Date(a.expense_data?.[0]?.date) - new Date(b.expense_data?.[0]?.date));
        //         break;
        //     case "desc_date":
        //         filteredData = filteredData.sort((a, b) => new Date(b.expense_data?.[0]?.date) - new Date(a.expense_data?.[0]?.date));
        //         break;
        //     case "asc_bill":
        //         filteredData = filteredData.sort((a, b) => {
        //             const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
        //             const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
        //             const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
        //             const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
        //             return aFirstDate - bFirstDate;
        //         });
        //         break;
        //     case "desc_bill":
        //         filteredData = filteredData.sort((a, b) => {
        //             const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
        //             const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
        //             const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
        //             const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
        //             return bFirstDate - aFirstDate;
        //         });
        //         break;
        //     case "asc_settlement":
        //         filteredData = filteredData.sort((a, b) => new Date(a.expense_data?.[0]?.final_update_datetime) - new Date(b.expense_data?.[0]?.final_update_datetime));

        //         break;
        //     case "desc_settlement":
        //         filteredData = filteredData.sort((a, b) => new Date(b.expense_data?.[0]?.final_update_datetime) - new Date(a.expense_data?.[0]?.final_update_datetime));
        //         break;
        //     default:
        //         filteredData = filteredData
        //         break;
        // }

        // // Sorting logic for Imprest Amount
        // switch (expenseAmountSorting) {
        //     case "asc_amount":
        //         filteredData = filteredData.sort((a, b) => {
        //             const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
        //             const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
        //             return aAmount - bAmount;
        //         });
        //         break;
        //     case "desc_amount":
        //         filteredData = filteredData.sort((a, b) => {
        //             const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
        //             const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
        //             return bAmount - aAmount;
        //         });
        //         break;
        //     default:
        //         filteredData = filteredData
        //         break;
        // }

        // Update the filtered data state
        setfilteredImprestExpenseData(filteredData);
    };

    // Helper function to calculate the total amount for an item
    const calculateTotalAmount = (item) => {
        if (item.rh_leave_status === "approved") {
            return (
                Number(item.approved_transportation) +
                Number(item.approved_accomodation) +
                Number(item.approved_fooding) +
                (item.other_details?.length > 0
                    ? item.other_details.reduce(
                        (total, other) => total + Number(other.approved_other || 0),
                        0
                    )
                    : 0)
            );
        } else {
            return (
                Number(item.transportation) +
                Number(item.accomodation) +
                Number(item.fooding) +
                (item.other_details?.length > 0
                    ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                    : 0)
            );
        }
    };

    useEffect(() => {
        applyFilters();
    }, [imprestExpenseData, selectedProject]);

    const tableRef = useRef(null);

    // ================= SORTING HELPER =================
    const applySorting = (data) => {
        let sortedData = [...data];

        // Sorting logic for Imprest
        switch (imprestDateSorting) {
            case "asc_date":
                sortedData = sortedData.sort((a, b) => new Date(a.date) - new Date(b.date));
                break;
            case "desc_date":
                sortedData = sortedData.sort((a, b) => new Date(b.date) - new Date(a.date));
                break;
            case "asc_bill":
                sortedData = sortedData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
                break;
            case "desc_bill":
                sortedData = sortedData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
                break;
            default:
                break;
        }

        // Sorting logic for Imprest Amount
        switch (imprestAmountSorting) {
            case "asc_amount":
                sortedData = sortedData.sort((a, b) => calculateTotalAmount(a) - calculateTotalAmount(b));
                break;
            case "desc_amount":
                sortedData = sortedData.sort((a, b) => calculateTotalAmount(b) - calculateTotalAmount(a));
                break;
            default:
                break;
        }

        // Sorting logic for Expense
        switch (expenseDateSorting) {
            case "asc_date":
                sortedData = sortedData.sort((a, b) => {
                    const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
                    const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
                    return aDate - bDate;
                });
                break;
            case "desc_date":
                sortedData = sortedData.sort((a, b) => {
                    const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
                    const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
                    return bDate - aDate;
                });
                break;
            case "asc_bill":
                sortedData = sortedData.sort((a, b) => {
                    const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                    const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                    const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
                    const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
                    return aFirstDate - bFirstDate;
                });
                break;
            case "desc_bill":
                sortedData = sortedData.sort((a, b) => {
                    const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                    const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                    const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
                    const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
                    return bFirstDate - aFirstDate;
                });
                break;
            case "asc_settlement":
                sortedData = sortedData.sort((a, b) => {
                    const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
                    const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
                    return aDate - bDate;
                });
                break;
            case "desc_settlement":
                sortedData = sortedData.sort((a, b) => {
                    const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
                    const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
                    return bDate - aDate;
                });
                break;
            default:
                break;
        }

        // Sorting logic for Expense Amount
        switch (expenseAmountSorting) {
            case "asc_amount":
                sortedData = sortedData.sort((a, b) => {
                    const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
                    const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
                    return aAmount - bAmount;
                });
                break;
            case "desc_amount":
                sortedData = sortedData.sort((a, b) => {
                    const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
                    const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
                    return bAmount - aAmount;
                });
                break;
            default:
                break;
        }

        return sortedData;
    };

    // const handleExcelDownload = () => {
    //     setIsExcelExport(true);

    //     setTimeout(() => {
    //         document.getElementById("downloadExcelBtn").click();

    //         setTimeout(() => {
    //             setIsExcelExport(false);
    //         }, 300);
    //     }, 100);
    // };

    const handleExcelDownload = () => {
        downloadImprestExpenseExcel(tableRef, "Details", "Imprest Expense DataSheet");
    };

    return (
        <div className="attendance-history-cont">
            <div className="attendance-subcont">
                <div className="field-cont">
                    {/* <div className="field-cont-div">
                        <div className="date-uppercase ">
                            <input
                                className="attendance-input-field width-10vw date-field date-field-filter"
                                placeholder="From Date"
                                type="date"
                                value={fromdate === "null" ? "" : fromdate}
                                onChange={(e) => setFromDate(e.target.value || "null")}
                            />
                        </div>
                        <hr className="field-cont-hr" />
                    </div>
                    <div className="field-cont-div">
                        <div className="date-uppercase ">
                            <input
                                className="attendance-input-field width-10vw date-field date-field-filter"
                                placeholder="To Date"
                                type="date"
                                value={todate === "null" ? "" : todate}
                                onChange={(e) => setToDate(e.target.value || "null")}
                            />
                        </div>
                        <hr className="field-cont-hr" />
                    </div> */}
                    <div className="field-cont-div">
                        {buffer1 ?
                            <div className="align-center form-loader">
                                <div className="bar-loader"></div>
                            </div>
                            :
                            <>
                                <Employee />
                                <Select
                                    className="attendance-input-field width-15vw"
                                    width="200px"
                                    options={[nullOption, ...options]} // Include "null" option at the beginning
                                    value={options.find(option => option.value === employeeGet) || nullOption}  // Ensure the correct option is selected
                                    placeholder="Select Employee Code"
                                    onChange={handleChange}
                                    isClearable
                                    styles={CSSForFilterDropdown}
                                />
                            </>}
                        <hr className="field-cont-hr" />
                    </div>

                    <div className="field-cont-div">
                        {/* <Project /> */}
                        {buffer ?
                            <div className="align-center justify-center">
                                <div className=" form-loader">
                                    <div className="bar-loader"></div>
                                </div>
                            </div>
                            :
                            <>
                                <div className="field-cont-div-svg">
                                    <SearchBig />
                                    <input
                                        className="attendance-input-field width-15vw  "
                                        placeholder="By Project Code, Name"
                                        type="text"
                                        value={selectedProject}
                                        onChange={(e) => setSelectedProject(e.target.value)}
                                    />
                                </div>
                            </>}
                        <hr className="field-cont-hr" />
                    </div>

                    <div className="field-cont-div">
                        {buffer1 ?
                            <div className="align-center form-loader">
                                <div className="bar-loader"></div>
                            </div>
                            :
                            <>
                                <CircularGrid />
                                <select
                                    className="attendance-input-field width-15vw   date-field"
                                    type="text"
                                    value={selectedDepartment}
                                    onChange={(e) => setSelectedDepartment(e.target.value)}
                                >
                                    <option value="null">All Department</option>
                                    {departmentLists
                                        .sort((a, b) => a.title - b.title)
                                        .map((i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        ))};
                                </select>
                            </>}
                        <hr className="field-cont-hr" />
                    </div>
                    <div title="Sort Filter" className="field-cont-div">
                        <Sort />
                        <select
                            className="attendance-input-field width-15vw   date-field"
                            type="text"
                            value={imprestDateSorting}
                            onChange={handleImprestDateSortChange}
                        >
                            <option value="null">No Imprest Filter</option>
                            <option value="asc_date">Asc. Imprest Date</option>
                            <option value="desc_date">Desc. Imprest Date</option>
                            <option value="asc_bill">Asc. Imprest Settlement</option>
                            <option value="desc_bill">Desc. Imprest Settlement</option>
                        </select>
                        <hr className="field-cont-hr" />
                    </div>
                    <div title="Sort Filter" className="field-cont-div">
                        <Sort />
                        <select
                            className="attendance-input-field width-15vw   date-field"
                            type="text"
                            value={imprestAmountSorting}
                            onChange={handleImprestAmountSortChange}
                        >
                            <option value="null">No Imprest Amount Filter</option>
                            <option value="asc_amount">Asc. Imprest Amount</option>
                            <option value="desc_amount">Desc. Imprest Amount</option>
                        </select>
                        <hr className="field-cont-hr" />
                    </div>
                    <div title="Sort Filter" className="field-cont-div">
                        <Sort />
                        <select
                            className="attendance-input-field width-15vw   date-field"
                            type="text"
                            value={expenseDateSorting}
                            onChange={handleExpenseDateSortChange}
                        >
                            <option value="null">No Expense Date Filter</option>
                            <option value="asc_date">Asc. Expense Date</option>
                            <option value="desc_date">Desc. Expense Date</option>
                            <option value="asc_bill">Asc. Expense Bills</option>
                            <option value="desc_bill">Desc. Expense Bills</option>
                            <option value="asc_settlement">Asc. Expense Settlement</option>
                            <option value="desc_settlement">Desc. Expense Settlement</option>
                        </select>
                        <hr className="field-cont-hr" />
                    </div>
                    <div title="Sort Filter" className="field-cont-div">
                        <Sort />
                        <select
                            className="attendance-input-field width-15vw   date-field"
                            type="text"
                            value={expenseAmountSorting}
                            onChange={handleExpenseAmountSortChange}
                        >
                            <option value="null">No Expense Amount Filter</option>
                            <option value="asc_amount">Asc. Expense Amount</option>
                            <option value="desc_amount">Desc. Expense Amount</option>
                        </select>
                        <hr className="field-cont-hr" />
                    </div>

                </div>
                <div className="btn-cont">
                    {/* <hr className="field-cont-hr" /> */}
                    {
                        buffer ? <div className="spinner-small"></div> :
                            // <DownloadTableExcel
                            //     // filename={`Expense Data ${fromdate === todate ? `${fromdate}` : `${fromdate} to ${todate}`} ${datetimefield}`}
                            //     filename={`Imprest Expense DataSheet`}
                            //     sheet="Details"
                            //     currentTableRef={tableRef.current}
                            // >
                            //     <button className="model-button   font-weight500   model-button-print">
                            //         <DownloadIcon />
                            //     </button>
                            // </DownloadTableExcel>
                            <>
                                {/* <button
                                    className="model-button model-button-print"
                                    onClick={handleExcelDownload}
                                >
                                    <DownloadIcon />
                                </button>

                                <DownloadTableExcel
                                    filename="Imprest Expense DataSheet"
                                    sheet="Details"
                                    currentTableRef={tableRef.current}
                                >
                                    <button
                                        id="downloadExcelBtn"
                                        style={{ display: "none" }}
                                    />
                                </DownloadTableExcel> */}
                                <button
                                    className="model-button model-button-print"
                                    onClick={handleExcelDownload}
                                >
                                    <DownloadIcon />
                                </button>
                            </>
                    }

                </div>
            </div>

            <div className="table-css-white-background-new scroll-container-table">
                <table ref={tableRef} className="">
                    <thead
                        style={{
                            position: "sticky",
                            top: "0",
                            backgroundColor: "#fff",
                            zIndex: "10",
                        }}
                    >
                        <tr className="custom-table-head-tr-0P">
                            <th className="table-heading">S. No.</th>
                            <th className="table-heading">Employee Details</th>
                            <th className="table-heading">Project Reference</th>
                            <th className="table-heading text-center">Imprest Details</th>
                            <th className="table-heading">Imprest Amount</th>
                            <th className="table-heading">Imprest Received Date</th>
                            <th className="table-heading">Imprest Approval Status</th>
                            <th className="table-heading">Expense Details</th>
                            <th className="table-heading">Expense Amount</th>
                            <th className="table-heading">Expense Bills Date Range</th>
                            <th className="table-heading">Expense Approval Status</th>
                        </tr>
                    </thead>
                    {/* <thead
                        style={{
                            position: "sticky",
                            top: "0",
                            backgroundColor: "#fff",
                            zIndex: "10",
                        }}
                    >
                        <tr className="custom-table-head-tr-0P">
                            <th className="table-heading">S. No.</th>
                            <th className="table-heading">Employee Details</th>
                        
                            <th className="table-heading">Project Code</th>
                            <th className="table-heading">Project Name</th>
                      
                            <th className="table-heading text-center">Imprest Name</th>
                            <th className="table-heading text-center">Imprest Date</th>
                            <th className="table-heading">Imprest Amount</th>
                            <th className="table-heading">Imprest Received Date</th>
                            <th className="table-heading">Imprest Approval Status</th>
                    
                            <th className="table-heading">Expense Name</th>
                            <th className="table-heading">Expense Date</th>
                            <th className="table-heading">Expense Amount</th>
                            <th className="table-heading">Expense Bills Date Range</th>
                            <th className="table-heading">Expense Approval Status</th>
                        </tr>
                    </thead> */}
                    {buffer ? <div className="spinner"></div> : //buffering logic
                        // <tbody>
                        //     {filteredImprestExpenseData
                        //         ?.map((item, index) => {
                        //             const expenseData = item?.expense_data?.length > 0 ? item.expense_data[0] : null;

                        //             // Check if expense details exist before mapping
                        //             const DatesList = expenseData?.expense_details?.length > 0
                        //                 ? expenseData.expense_details.map(exp => exp.date).sort((a, b) => new Date(a) - new Date(b))
                        //                 : [];

                        //             const FirstBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[0]);
                        //             const LastBillDate = DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[DatesList.length - 1]);

                        //             // console.log("DatesList")
                        //             // console.log(DatesList)
                        //             return (
                        //                 <>
                        //                     <tr className="custom-table-head-td" key={index}>
                        //                         <td className="table-body" style={{ verticalAlign: "top" }}>{index + 1}</td>
                        //                         <td className="table-body" style={{ textAlign: "center", verticalAlign: "top"}}>
                        //                             {/* <CustomImageModal customStyle>
                        //                                 {item?.profilepic ? (
                        //                                     <img
                        //                                         src={`${IMAGE_URL}${item.profilepic}`}
                        //                                         alt="profile" className="profile-img"
                        //                                     />
                        //                                 ) : (
                        //                                     <UserDefaultLogo user={{ name: item.emp_name, profilepic: item.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                        //                                 )}
                        //                             </CustomImageModal> */}
                        //                             {!isExcelExport && (
                        //                                 <CustomImageModal customStyle>
                        //                                     {item?.profilepic ? (
                        //                                         <img
                        //                                             src={`${IMAGE_URL}${item.profilepic}`}
                        //                                             alt="profile"
                        //                                             className="profile-img"
                        //                                         />
                        //                                     ) : (
                        //                                         <UserDefaultLogo
                        //                                             user={{
                        //                                                 name: item.emp_name,
                        //                                                 profilepic: item.profilepic,
                        //                                             }}
                        //                                             customStyleforParent="reqOutDuty-default-logo-dashboard"
                        //                                             customStyleforChild="profile-img"
                        //                                         />
                        //                                     )}
                        //                                 </CustomImageModal>
                        //                             )}
                        //                             <p>{item.empcode}-{item.emp_name}</p>
                        //                         </td>
                        //                         {/* <td className="table-body">
                        //                             {item.mantra_project_details?.mantra_project_id ?
                        //                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        //                                     <tbody>
                        //                                         <tr>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>Project Code</td>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                             <td className="align-right word-wrap-20vw">
                        //                                                 {item.mantra_project_details?.mantra_project_code}
                        //                                             </td>
                        //                                         </tr>
                        //                                         <tr>
                        //                                             <td className="table-body" >Project Name</td>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                             <td className="align-right word-wrap-20vw">
                        //                                                 {item.mantra_project_details?.mantra_project_name}
                        //                                             </td>
                        //                                         </tr>

                        //                                     </tbody>
                        //                                 </table> :
                        //                                 <div className="align-center justify-center">
                        //                                     - No Project Referenced -
                        //                                 </div>
                        //                             }
                        //                         </td> */}
                        //                         {/* <td className="table-body">
                        //                             {item?.mantra_project_details?.mantra_project_id ? (
                        //                                 // Priority 1: Mantra project exists
                        //                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        //                                     <tbody>
                        //                                         <tr>
                        //                                             <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                             <td className="align-right word-wrap-10vw">
                        //                                                 {item?.mantra_project_details?.mantra_project_code}
                        //                                             </td>
                        //                                         </tr>
                        //                                         <tr>
                        //                                             <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                             <td className="align-right  word-wrap-15vw">
                        //                                                 {item?.mantra_project_details?.mantra_project_name}
                        //                                             </td>
                        //                                         </tr>
                        //                                     </tbody>
                        //                                 </table>
                        //                             ) : item?.project_id ? (
                        //                                 // Priority 2: Fallback to ref project
                        //                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        //                                     <tbody>
                        //                                         <tr>
                        //                                             <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                             <td className="align-right  word-wrap-10vw">
                        //                                                 {item?.ref_project_code}
                        //                                             </td>
                        //                                         </tr>
                        //                                         <tr>
                        //                                             <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                        //                                             <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                             <td className="align-right word-wrap-15vw">
                        //                                                 {item?.ref_project_name}
                        //                                             </td>
                        //                                         </tr>
                        //                                     </tbody>
                        //                                 </table>
                        //                             ) : (
                        //                                 // Priority 3: No project at all
                        //                                 <div className="justify-center">
                        //                                     - No Project Referenced -
                        //                                 </div>
                        //                             )}
                        //                         </td> */}
                        //                         <td className="table-body" style={{ verticalAlign: "top", padding: 0 }}>
                        //                             {item?.mantra_project_details?.mantra_project_id ? (
                        //                                 <table style={{ borderCollapse: "collapse", width: "100%", height: "100%" }}>
                        //                                     <thead>
                        //                                         <tr>
                        //                                             <th className="text-left" style={{ padding: "4px"}}>Project Code</th>
                        //                                             <th className="text-left" style={{ padding: "4px"}}>Project Name</th>
                        //                                         </tr>
                        //                                     </thead>
                        //                                     <tbody>
                        //                                         <tr>
                        //                                             {/* Note the rowSpan=6 here. This tells Excel to merge the cell down over the blank rows generated by the tall Status columns */}
                        //                                             <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                                 {item?.mantra_project_details?.mantra_project_code}
                        //                                             </td>
                        //                                             <td rowSpan={6} className="word-wrap-15vw" style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                                 {item?.mantra_project_details?.mantra_project_name}
                        //                                             </td>
                        //                                         </tr>
                        //                                     </tbody>
                        //                                 </table>
                        //                             ) : item?.project_id ? (
                        //                                 <table style={{ borderCollapse: "collapse", width: "100%", height: "100%" }}>
                        //                                     <thead>
                        //                                         <tr>
                        //                                             <th className="text-left" style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Project Code</th>
                        //                                             <th className="text-left" style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Project Name</th>
                        //                                         </tr>
                        //                                     </thead>
                        //                                     <tbody>
                        //                                         <tr>
                        //                                             <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                                 {item?.ref_project_code}
                        //                                             </td>
                        //                                             <td rowSpan={6} className="word-wrap-15vw" style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                                 {item?.ref_project_name}
                        //                                             </td>
                        //                                         </tr>
                        //                                     </tbody>
                        //                                 </table>
                        //                             ) : (
                        //                                 <div className="justify-center" style={{ padding: "4px" }}>- No Project Referenced -</div>
                        //                             )}
                        //                         </td>

                        //                         {/* <td className="table-body">
                        //                             <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        //                                 <tbody>
                        //                                     <tr>
                        //                                         <td className="table-body" >Imprest Name</td>
                        //                                         <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                        //                                         <td className="align-right word-wrap-10vw">
                        //                                             {item?.mantra_project_details?.mantra_project_id
                        //                                                 ? `${item?.mantra_project_details?.mantra_project_code}-${item?.mantra_project_details?.mantra_project_name}`
                        //                                                 : `${item.project_name}`}
                        //                                         </td>
                        //                                     </tr>
                        //                                     <tr>
                        //                                         <td className="table-body" style={{ paddingBottom: "" }}>Imprest Date</td>
                        //                                         <td style={{ padding: "0px 4px" }}>:</td>
                        //                                         <td className="align-right">
                        //                                             {formatDate(item.date)}
                        //                                         </td>
                        //                                     </tr>

                        //                                 </tbody>
                        //                             </table>
                        //                         </td> */}
                        //                         <td className="table-body" style={{ verticalAlign: "top", padding: 0 }}>
                        //                             <table style={{ borderCollapse: "collapse", width: "100%", height: "100%" }}>
                        //                                 <thead>
                        //                                     <tr>
                        //                                         <th className="text-left" style={{ padding: "4px" }}>Imprest Name</th>
                        //                                         <th className="text-left" style={{ padding: "4px" }}>Imprest Date</th>
                        //                                     </tr>
                        //                                 </thead>
                        //                                 <tbody>
                        //                                     <tr>
                        //                                         <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                             {item?.mantra_project_details?.mantra_project_id
                        //                                                 ? `${item?.mantra_project_details?.mantra_project_code}-${item?.mantra_project_details?.mantra_project_name}`
                        //                                                 : `${item.project_name}`}
                        //                                         </td>
                        //                                         <td rowSpan={6} style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                             {formatDate(item.date)}
                        //                                         </td>
                        //                                     </tr>
                        //                                 </tbody>
                        //                             </table>
                        //                         </td>

                        //                         {/* {item.rh_leave_status === "approved" ?
                        //                             <td className="table-body align-right">

                        //                                 {formatCurrencyIndian(
                        //                                     Number(item.approved_transportation) +
                        //                                     Number(item.approved_accomodation) +
                        //                                     Number(item.approved_fooding) +
                        //                                     (item.other_details?.length > 0
                        //                                         ? item.other_details.reduce(
                        //                                             (total, other) =>
                        //                                                 total + Number(other.approved_other || 0),
                        //                                             0
                        //                                         )
                        //                                         : 0)
                        //                                 )}
                        //                                 {" "}
                        //                                 Rs.

                        //                             </td>
                        //                             :
                        //                             <td className="table-body align-right">

                        //                                 {formatCurrencyIndian(
                        //                                     Number(item.transportation) +
                        //                                     Number(item.accomodation) +
                        //                                     Number(item.fooding) +
                        //                                     (item.other_details?.length > 0
                        //                                         ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                        //                                         : 0)
                        //                                 )}
                        //                                 {" "}
                        //                                 Rs.

                        //                             </td>} */}

                        //                             {/* IMPREST AMOUNTS & STATUS */}
                        //                         <td className="table-body align-right" style={{ verticalAlign: "top" }}>
                        //                             {item.rh_leave_status === "approved"
                        //                                 ? formatCurrencyIndian(
                        //                                     Number(item.approved_transportation) +
                        //                                         Number(item.approved_accomodation) +
                        //                                         Number(item.approved_fooding) +
                        //                                         (item.other_details?.length > 0
                        //                                             ? item.other_details.reduce((total, other) => total + Number(other.approved_other || 0), 0)
                        //                                             : 0)
                        //                                 )
                        //                                 : formatCurrencyIndian(
                        //                                     Number(item.transportation) +
                        //                                         Number(item.accomodation) +
                        //                                         Number(item.fooding) +
                        //                                         (item.other_details?.length > 0
                        //                                             ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                        //                                             : 0)
                        //                                 )}{" "}
                        //                             Rs.
                        //                         </td>
                        //                         <td className="table-body" style={{ verticalAlign: "top" }}>
                        //                             {item.account_update_datetime ? <>At: {(formatDate(item.account_update_datetime))}</> : null}</td>
                        //                         <td title="Imprest Approval Status" className="table-body width-10vw" style={{ verticalAlign: "top" }}>
                        //                             <span
                        //                                 request-status={item.rh_leave_status}
                        //                                 className="request-status "
                        //                             >
                        //                                 {item.rh_leave_status === "approved" ?
                        //                                     <>
                        //                                         Rh ({item.rh_assigned}-{item.rh_assigned_name}) Approved
                        //                                         {item.rh_update_datetime ? <><br />At: {formatDateTime(item.rh_update_datetime).date}</> : ''}
                        //                                     </>
                        //                                     : item.rh_leave_status === "rejected"
                        //                                         ? <>Rh ✖,<br />Rh Reject Reason:<br />"{item.rejection_reason}"</>
                        //                                         : "Pending For Rh Approval ⌛"}
                        //                             </span>
                        //                             {/* <br /> */}
                        //                             <br />
                        //                             <span
                        //                                 request-status={item.admin_leave_status}
                        //                                 className="request-status "
                        //                             >
                        //                                 {item.admin_leave_status === "approved" ?
                        //                                     <>
                        //                                         Admin {item.admin_update_by ? `(${item.admin_update_by}-${item.admin_update_by_name})` : ''} Approved
                        //                                         {item.admin_update_datetime ? <><br />At: {formatDateTime(item.admin_update_datetime).date}</> : ''}
                        //                                     </>
                        //                                     : item.admin_leave_status === "rejected"
                        //                                         ? <>Admin ✖,<br />Admin Reject Reason: "{item.admin_rejection_reason}"</>
                        //                                         : "Pending For Admin Approval ⌛"}
                        //                             </span>
                        //                             {/* <br /> */}
                        //                             <br />
                        //                             <span
                        //                                 request-status={item.account_leave_status}
                        //                                 className="request-status "
                        //                             >
                        //                                 {item.account_leave_status === "approved" ?
                        //                                     <>
                        //                                         Accounts{item.account_update_by ? `(${item.account_update_by}-${item.account_update_by_name})` : ''} Approved
                        //                                         {item.account_update_datetime ? <><br />At: {formatDateTime(item.account_update_datetime).date}</> : ''}
                        //                                     </>
                        //                                     : item.account_leave_status === "rejected"
                        //                                         ? <>Accounts ✖,<br />Accounts Reject Reason:<br />"{item.account_rejection_reason}"</>
                        //                                         : "Pending For Account Approval ⌛"}
                        //                             </span>
                        //                         </td>
                        //                         {/* {
                        //                             item.expense_data.length > 0 ?
                        //                                 <>
                        //                                     <td className="table-body">
                        //                                         <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        //                                             <tbody>
                        //                                                 <tr>
                        //                                                     <td className="" >Expense Name</td>
                        //                                                     <td style={{ padding: "0px 4px" }}>:</td>
                        //                                                     <td className="align-right word-wrap-10vw">
                        //                                                         {item.expense_data[0]?.name}
                        //                                                     </td>
                        //                                                 </tr>
                        //                                                 <tr>
                        //                                                     <td className="table-body" style={{ paddingBottom: "5px" }}>Expense Date</td>
                        //                                                     <td style={{ padding: "0px 4px" }}>:</td>
                        //                                                     <td className="align-right">
                        //                                                         {formatDate(item.expense_data[0]?.date)}
                        //                                                     </td>
                        //                                                 </tr>

                        //                                             </tbody>
                        //                                         </table>
                        //                                     </td>
                        //                                     <td className="table-body align-center">{item.expense_data[0]?.utilized_amount ? formatRoundoff2D(item.expense_data[0]?.utilized_amount) : '-'} Rs</td>
                        //                                     <td className="table-body">{FirstBillDate} to {LastBillDate}</td>
                        //                                     <td title="Expense Approval Status" className="table-body">
                        //                                         <span
                        //                                             request-status={item.expense_data[0]?.rh_status}
                        //                                             className="request-status "
                        //                                         >
                        //                                             {item.expense_data[0]?.rh_status === "pending"
                        //                                                 ? "Pending For Rh Approval ⌛"
                        //                                                 : item.expense_data[0]?.rh_status === "rejected"
                        //                                                     ? `Rh Reject Reason : ${item.expense_data[0]?.rh_rejection_reason}`
                        //                                                     : `Rh${item.expense_data[0]?.rh_assigned ? `(${item.expense_data[0]?.rh_assigned}-${item.expense_data[0]?.rh_assigned_name}) ` : ''}: Verified Amounts for Bills ${item.expense_data[0]?.rh_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.rh_update_datetime).date}` : ''}`}
                        //                                         </span>
                        //                                         <br />
                        //                                         <span
                        //                                             request-status={item.expense_data[0]?.account_status_a}
                        //                                             className="request-status "
                        //                                         >
                        //                                             {item.expense_data[0]?.account_status_a === "pending"
                        //                                                 ? "Pending For Account Approval ⌛"
                        //                                                 : item.expense_data[0]?.account_status_a === "rejected"
                        //                                                     ? `Accounts Reject Reason : ${item.expense_data[0]?.account1_rejection_reason}`
                        //                                                     : `Accounts${item.expense_data[0]?.account_update_by ? `(${item.expense_data[0]?.account_update_by}-${item.expense_data[0]?.account_update_by_name}) ` : ''}: Bills Verified ${item.expense_data[0]?.account_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.account_update_datetime).date}` : ''}`}
                        //                                         </span>
                        //                                         <br />
                        //                                         <span
                        //                                             request-status={item.expense_data[0]?.admin_status}
                        //                                             className="request-status "
                        //                                             title={item.expense_data[0]?.admin_status === "rejected" ? `Admin Reject Reason : ${item.expense_data[0]?.admin_rejection_reason}` : ""}
                        //                                         >
                        //                                             {item.expense_data[0]?.admin_status === "pending"
                        //                                                 ? "Pending For Admin Approval ⌛"
                        //                                                 : item.expense_data[0]?.admin_status === "rejected"
                        //                                                     ? `Admin Rejection Reason : ${item.expense_data[0]?.admin_rejection_reason}`
                        //                                                     : `Admin${item.expense_data[0]?.admin_update_by ? `(${item.expense_data[0]?.admin_update_by}-${item.expense_data[0]?.admin_update_by_name}) ` : ''}: Approved After Final Verification  ${item.expense_data[0]?.admin_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.admin_update_datetime).date}` : ''}`}
                        //                                         </span>
                        //                                         <br />
                        //                                         <span
                        //                                             request-status={item.expense_data[0]?.account_status_b}
                        //                                             className="request-status "
                        //                                         >
                        //                                             {item.expense_data[0]?.account_status_b === "pending"
                        //                                                 ? "Final Stage Pending⌛"
                        //                                                 : item.expense_data[0]?.account_status_b === "rejected"
                        //                                                     ? `Final Rejection Reason : ${item.expense_data[0]?.account2_rejection_reason}`
                        //                                                     : `Final${item.expense_data[0]?.final_update_by ? `(${item.expense_data[0]?.final_update_by}-${item.expense_data[0]?.final_update_by_name}) ` : ''}: Approved And Settled ${item.expense_data[0]?.final_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.final_update_datetime).date}` : ''}`}
                        //                                         </span>
                        //                                     </td>
                        //                                 </> :
                        //                                 <td colSpan={4} className="table-body align-center">- No Expense Details Updated Yet -</td>

                        //                         } */}
                        //                         {item.expense_data.length > 0 ? (
                        //                             <>
                        //                                 <td className="table-body" style={{ verticalAlign: "top", padding: 0 }}>
                        //                                     <table style={{ borderCollapse: "collapse", width: "100%", height: "100%" }}>
                        //                                         <thead>
                        //                                             <tr>
                        //                                                 <th className="text-left" style={{ padding: "4px" }}>Expense Name</th>
                        //                                                 <th className="text-left" style={{ padding: "4px" }}>Expense Date</th>
                        //                                             </tr>
                        //                                         </thead>
                        //                                         <tbody>
                        //                                             <tr>
                        //                                                 <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                                     {item.expense_data[0]?.name}
                        //                                                 </td>
                        //                                                 <td rowSpan={6} style={{ verticalAlign: "top", padding: "4px" }}>
                        //                                                     {formatDate(item.expense_data[0]?.date)}
                        //                                                 </td>
                        //                                             </tr>
                        //                                         </tbody>
                        //                                     </table>
                        //                                 </td>

                        //                                 <td className="table-body align-center" style={{ verticalAlign: "top" }}>
                        //                                     {item.expense_data[0]?.utilized_amount ? formatRoundoff2D(item.expense_data[0]?.utilized_amount) : "-"}{" "}
                        //                                     Rs
                        //                                 </td>
                        //                                 <td className="table-body" style={{ verticalAlign: "top" }}>
                        //                                     {FirstBillDate} to {LastBillDate}
                        //                                 </td>
                        //                                 <td title="Expense Approval Status" className="table-body" style={{ verticalAlign: "top" }}>
                        //                                     <span request-status={item.expense_data[0]?.rh_status} className="request-status ">
                        //                                         {item.expense_data[0]?.rh_status === "pending"
                        //                                             ? "Pending For Rh Approval ⌛"
                        //                                             : item.expense_data[0]?.rh_status === "rejected"
                        //                                             ? `Rh Reject Reason : ${item.expense_data[0]?.rh_rejection_reason}`
                        //                                             : `Rh${item.expense_data[0]?.rh_assigned ? `(${item.expense_data[0]?.rh_assigned}-${item.expense_data[0]?.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${item.expense_data[0]?.rh_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.rh_update_datetime).date}` : ""}`}
                        //                                     </span>
                        //                                     <br />
                        //                                     <span request-status={item.expense_data[0]?.account_status_a} className="request-status ">
                        //                                         {item.expense_data[0]?.account_status_a === "pending"
                        //                                             ? "Pending For Account Approval ⌛"
                        //                                             : item.expense_data[0]?.account_status_a === "rejected"
                        //                                             ? `Accounts Reject Reason : ${item.expense_data[0]?.account1_rejection_reason}`
                        //                                             : `Accounts${item.expense_data[0]?.account_update_by ? `(${item.expense_data[0]?.account_update_by}-${item.expense_data[0]?.account_update_by_name}) ` : ""}: Bills Verified ${item.expense_data[0]?.account_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.account_update_datetime).date}` : ""}`}
                        //                                     </span>
                        //                                     <br />
                        //                                     <span request-status={item.expense_data[0]?.admin_status} className="request-status " title={item.expense_data[0]?.admin_status === "rejected" ? `Admin Reject Reason : ${item.expense_data[0]?.admin_rejection_reason}` : ""}>
                        //                                         {item.expense_data[0]?.admin_status === "pending"
                        //                                             ? "Pending For Admin Approval ⌛"
                        //                                             : item.expense_data[0]?.admin_status === "rejected"
                        //                                             ? `Admin Rejection Reason : ${item.expense_data[0]?.admin_rejection_reason}`
                        //                                             : `Admin${item.expense_data[0]?.admin_update_by ? `(${item.expense_data[0]?.admin_update_by}-${item.expense_data[0]?.admin_update_by_name}) ` : ""}: Approved After Final Verification  ${item.expense_data[0]?.admin_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.admin_update_datetime).date}` : ""}`}
                        //                                     </span>
                        //                                     <br />
                        //                                     <span request-status={item.expense_data[0]?.account_status_b} className="request-status ">
                        //                                         {item.expense_data[0]?.account_status_b === "pending"
                        //                                             ? "Final Stage Pending⌛"
                        //                                             : item.expense_data[0]?.account_status_b === "rejected"
                        //                                             ? `Final Rejection Reason : ${item.expense_data[0]?.account2_rejection_reason}`
                        //                                             : `Final${item.expense_data[0]?.final_update_by ? `(${item.expense_data[0]?.final_update_by}-${item.expense_data[0]?.final_update_by_name}) ` : ""}: Approved And Settled ${item.expense_data[0]?.final_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.final_update_datetime).date}` : ""}`}
                        //                                     </span>
                        //                                 </td>
                        //                             </>
                        //                         ) : (
                        //                             <td colSpan={4} className="table-body align-center" style={{ verticalAlign: "top" }}>
                        //                                 - No Expense Details Updated Yet -
                        //                             </td>
                        //                         )}
                        //                     </tr>
                        //                 </>
                        //             )
                        //         }
                        //         )}
                        // </tbody>

                        <tbody>
                            {filteredImprestExpenseData?.map((item, index) => {
                                const expenseData = item?.expense_data?.length > 0 ? item.expense_data[0] : null;

                                const DatesList =
                                    expenseData?.expense_details?.length > 0
                                        ? expenseData.expense_details
                                            .map((exp) => exp.date)
                                            .sort((a, b) => new Date(a) - new Date(b))
                                        : [];

                                const FirstBillDate =
                                    DatesList.length === 0 ? '"Details Pending"' : formatDate(DatesList[0]);
                                const LastBillDate =
                                    DatesList.length === 0
                                        ? '"Details Pending"'
                                        : formatDate(DatesList[DatesList.length - 1]);

                                return (
                                    <tr className="custom-table-head-td" key={index}>
                                        <td className="table-body" >{index + 1}</td>
                                        <td className="table-body" style={{ textAlign: "center" }}>
                                            {/* {!isExcelExport && ( */}
                                            <CustomImageModal customStyle>
                                                {item?.profilepic ? (
                                                    <img
                                                        src={`${IMAGE_URL}${item.profilepic}`}
                                                        alt="profile"
                                                        className="profile-img"
                                                    />
                                                ) : (
                                                    <UserDefaultLogo
                                                        user={{
                                                            name: item.emp_name,
                                                            profilepic: item.profilepic,
                                                        }}
                                                        customStyleforParent="reqOutDuty-default-logo-dashboard"
                                                        customStyleforChild="profile-img"
                                                    />
                                                )}
                                            </CustomImageModal>
                                            {/* )} */}
                                            <p>
                                                {item.empcode}-{item.emp_name}
                                            </p>
                                        </td>
                                        {/* -------------------------------------------new chnges  */}
                                        {/* <td className="table-body">
                                            {item?.mantra_project_details?.mantra_project_id ? (
                                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-left" style={{ padding: "4px" }}>Project Code</th>
                                                            <th className="text-left" style={{ padding: "4px" }}>Project Name</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                         
                                                            <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                                                                {item?.mantra_project_details?.mantra_project_code}
                                                            </td>
                                                            <td rowSpan={6} className="word-wrap-15vw" style={{ verticalAlign: "top", padding: "4px" }}>
                                                                {item?.mantra_project_details?.mantra_project_name}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : item?.project_id ? (
                                                <table style={{ borderCollapse: "collapse", width: "100%", height: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-left" style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Project Code</th>
                                                            <th className="text-left" style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Project Name</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                                                                {item?.ref_project_code}
                                                            </td>
                                                            <td rowSpan={6} className="word-wrap-15vw" style={{ verticalAlign: "top", padding: "4px" }}>
                                                                {item?.ref_project_name}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div className="justify-center" style={{ padding: "4px" }}>- No Project Referenced -</div>
                                            )}
                                        </td> */}

                                        <td className="table-body">
                                            {item?.mantra_project_details?.mantra_project_id ? (
                                                // Priority 1: Mantra project exists
                                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                                            <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right word-wrap-10vw">
                                                                {item?.mantra_project_details?.mantra_project_code}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                                            <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right  word-wrap-15vw">
                                                                {item?.mantra_project_details?.mantra_project_name}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : item?.project_id ? (
                                                // Priority 2: Fallback to ref project
                                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                                            <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right  word-wrap-10vw">
                                                                {item?.ref_project_code}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                                            <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right word-wrap-15vw">
                                                                {item?.ref_project_name}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : (
                                                // Priority 3: No project at all
                                                <div className="justify-center">
                                                    - No Project Referenced -
                                                </div>
                                            )}
                                        </td>

                                        {/* <td className="table-body" style={{ verticalAlign: "top", padding: 0 }}>
                                            <table style={{ borderCollapse: "collapse", width: "100%", height: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th className="text-left" style={{ padding: "4px" }}>Imprest Name</th>
                                                        <th className="text-left" style={{ padding: "4px" }}>Imprest Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                                                            {item?.mantra_project_details?.mantra_project_id
                                                                ? `${item?.mantra_project_details?.mantra_project_code}-${item?.mantra_project_details?.mantra_project_name}`
                                                                : `${item.project_name}`}
                                                        </td>
                                                        <td rowSpan={6} style={{ verticalAlign: "top", padding: "4px" }}>
                                                            {formatDate(item.date)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td> */}
                                        <td className="table-body">
                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td className="table-body" >Imprest Name</td>
                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                        <td className="align-right word-wrap-10vw">
                                                            {item?.mantra_project_details?.mantra_project_id
                                                                ? `${item?.mantra_project_details?.mantra_project_code}-${item?.mantra_project_details?.mantra_project_name}`
                                                                : `${item.project_name}`}
                                                            {/* {item.mantra_project_details?.mantra_project_code}-{item.mantra_project_details?.mantra_project_name} */}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-body" style={{ paddingBottom: "" }}>Imprest Date</td>
                                                        <td style={{ padding: "0px 4px" }}>:</td>
                                                        <td className="align-right">
                                                            {formatDate(item.date)}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </td>

                                        <td className="table-body align-right">
                                            {item.rh_leave_status === "approved"
                                                ? formatCurrencyIndian(
                                                    Number(item.approved_transportation) +
                                                    Number(item.approved_accomodation) +
                                                    Number(item.approved_fooding) +
                                                    (item.other_details?.length > 0
                                                        ? item.other_details.reduce((total, other) => total + Number(other.approved_other || 0), 0)
                                                        : 0)
                                                )
                                                : formatCurrencyIndian(
                                                    Number(item.transportation) +
                                                    Number(item.accomodation) +
                                                    Number(item.fooding) +
                                                    (item.other_details?.length > 0
                                                        ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                                                        : 0)
                                                )}{" "}
                                            Rs.
                                        </td>

                                        <td className="table-body" >
                                            {item.account_update_datetime ? <>At: {(formatDate(item.account_update_datetime))}</> : null}</td>
                                        <td title="Imprest Approval Status" className="table-body width-10vw" >
                                            <span
                                                request-status={item.rh_leave_status}
                                                className="request-status "
                                            >
                                                {item.rh_leave_status === "approved" ?
                                                    <>
                                                        Rh ({item.rh_assigned}-{item.rh_assigned_name}) Approved
                                                        {item.rh_update_datetime ? <><br />At: {formatDateTime(item.rh_update_datetime).date}</> : ''}
                                                    </>
                                                    : item.rh_leave_status === "rejected"
                                                        ? <>Rh ✖,<br />Rh Reject Reason:<br />"{item.rejection_reason}"</>
                                                        : "Pending For Rh Approval ⌛"}
                                            </span>
                                            {/* <br /> */}
                                            <br />
                                            <span
                                                request-status={item.admin_leave_status}
                                                className="request-status "
                                            >
                                                {item.admin_leave_status === "approved" ?
                                                    <>
                                                        Admin {item.admin_update_by ? `(${item.admin_update_by}-${item.admin_update_by_name})` : ''} Approved
                                                        {item.admin_update_datetime ? <><br />At: {formatDateTime(item.admin_update_datetime).date}</> : ''}
                                                    </>
                                                    : item.admin_leave_status === "rejected"
                                                        ? <>Admin ✖,<br />Admin Reject Reason: "{item.admin_rejection_reason}"</>
                                                        : "Pending For Admin Approval ⌛"}
                                            </span>
                                            {/* <br /> */}
                                            <br />
                                            <span
                                                request-status={item.account_leave_status}
                                                className="request-status "
                                            >
                                                {item.account_leave_status === "approved" ?
                                                    <>
                                                        Accounts{item.account_update_by ? `(${item.account_update_by}-${item.account_update_by_name})` : ''} Approved
                                                        {item.account_update_datetime ? <><br />At: {formatDateTime(item.account_update_datetime).date}</> : ''}
                                                    </>
                                                    : item.account_leave_status === "rejected"
                                                        ? <>Accounts ✖,<br />Accounts Reject Reason:<br />"{item.account_rejection_reason}"</>
                                                        : "Pending For Account Approval ⌛"}
                                            </span>
                                        </td>

                                        {item.expense_data.length > 0 ? (
                                            <>
                                                {/* <td className="table-body" >
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-left" style={{ padding: "4px" }}>Expense Name</th>
                                                                <th className="text-left" style={{ padding: "4px" }}>Expense Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td rowSpan={6} className="word-wrap-10vw" style={{ verticalAlign: "top", padding: "4px" }}>
                                                                    {item.expense_data[0]?.name}
                                                                </td>
                                                                <td rowSpan={6} style={{ verticalAlign: "top", padding: "4px" }}>
                                                                    {formatDate(item.expense_data[0]?.date)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td> */}
                                                <td className="table-body">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="" >Expense Name</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right word-wrap-10vw">
                                                                    {item.expense_data[0]?.name}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Expense Date</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatDate(item.expense_data[0]?.date)}
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </td>

                                                <td className="table-body align-center" >
                                                    {item.expense_data[0]?.utilized_amount ? formatRoundoff2D(item.expense_data[0]?.utilized_amount) : "-"}{" "}
                                                    Rs
                                                </td>
                                                <td className="table-body" >
                                                    {FirstBillDate} to {LastBillDate}
                                                </td>
                                                {/* <td title="Expense Approval Status" className="table-body" >
                                                    <span request-status={item.expense_data[0]?.rh_status} className="request-status ">
                                                        {item.expense_data[0]?.rh_status === "pending"
                                                            ? "Pending For Rh Approval ⌛"
                                                            : item.expense_data[0]?.rh_status === "rejected"
                                                                ? `Rh Reject Reason : ${item.expense_data[0]?.rh_rejection_reason}`
                                                                : `Rh${item.expense_data[0]?.rh_assigned ? `(${item.expense_data[0]?.rh_assigned}-${item.expense_data[0]?.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${item.expense_data[0]?.rh_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.rh_update_datetime).date}` : ""}`}
                                                    </span>
                                                    <br />
                                                    <span request-status={item.expense_data[0]?.account_status_a} className="request-status ">
                                                        {item.expense_data[0]?.account_status_a === "pending"
                                                            ? "Pending For Account Approval ⌛"
                                                            : item.expense_data[0]?.account_status_a === "rejected"
                                                                ? `Accounts Reject Reason : ${item.expense_data[0]?.account1_rejection_reason}`
                                                                : `Accounts${item.expense_data[0]?.account_update_by ? `(${item.expense_data[0]?.account_update_by}-${item.expense_data[0]?.account_update_by_name}) ` : ""}: Bills Verified ${item.expense_data[0]?.account_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.account_update_datetime).date}` : ""}`}
                                                    </span>
                                                    <br />
                                                    <span request-status={item.expense_data[0]?.admin_status} className="request-status " title={item.expense_data[0]?.admin_status === "rejected" ? `Admin Reject Reason : ${item.expense_data[0]?.admin_rejection_reason}` : ""}>
                                                        {item.expense_data[0]?.admin_status === "pending"
                                                            ? "Pending For Admin Approval ⌛"
                                                            : item.expense_data[0]?.admin_status === "rejected"
                                                                ? `Admin Rejection Reason : ${item.expense_data[0]?.admin_rejection_reason}`
                                                                : `Admin${item.expense_data[0]?.admin_update_by ? `(${item.expense_data[0]?.admin_update_by}-${item.expense_data[0]?.admin_update_by_name}) ` : ""}: Approved After Final Verification  ${item.expense_data[0]?.admin_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.admin_update_datetime).date}` : ""}`}
                                                    </span>
                                                    <br />
                                                    <span request-status={item.expense_data[0]?.account_status_b} className="request-status ">
                                                        {item.expense_data[0]?.account_status_b === "pending"
                                                            ? "Final Stage Pending⌛"
                                                            : item.expense_data[0]?.account_status_b === "rejected"
                                                                ? `Final Rejection Reason : ${item.expense_data[0]?.account2_rejection_reason}`
                                                                : `Final${item.expense_data[0]?.final_update_by ? `(${item.expense_data[0]?.final_update_by}-${item.expense_data[0]?.final_update_by_name}) ` : ""}: Approved And Settled ${item.expense_data[0]?.final_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.final_update_datetime).date}` : ""}`}
                                                    </span>
                                                </td> */}
                                                <td title="Expense Approval Status" className="table-body">
                                                    <span
                                                        request-status={item.expense_data[0]?.rh_status}
                                                        className="request-status "
                                                    >
                                                        {item.expense_data[0]?.rh_status === "pending"
                                                            ? "Pending For Rh Approval ⌛"
                                                            : item.expense_data[0]?.rh_status === "rejected"
                                                                ? `Rh Reject Reason : ${item.expense_data[0]?.rh_rejection_reason}`
                                                                : `Rh${item.expense_data[0]?.rh_assigned ? `(${item.expense_data[0]?.rh_assigned}-${item.expense_data[0]?.rh_assigned_name}) ` : ''}: Verified Amounts for Bills ${item.expense_data[0]?.rh_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.rh_update_datetime).date}` : ''}`}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={item.expense_data[0]?.account_status_a}
                                                        className="request-status "
                                                    >
                                                        {item.expense_data[0]?.account_status_a === "pending"
                                                            ? "Pending For Account Approval ⌛"
                                                            : item.expense_data[0]?.account_status_a === "rejected"
                                                                ? `Accounts Reject Reason : ${item.expense_data[0]?.account1_rejection_reason}`
                                                                : `Accounts${item.expense_data[0]?.account_update_by ? `(${item.expense_data[0]?.account_update_by}-${item.expense_data[0]?.account_update_by_name}) ` : ''}: Bills Verified ${item.expense_data[0]?.account_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.account_update_datetime).date}` : ''}`}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={item.expense_data[0]?.admin_status}
                                                        className="request-status "
                                                        title={item.expense_data[0]?.admin_status === "rejected" ? `Admin Reject Reason : ${item.expense_data[0]?.admin_rejection_reason}` : ""}
                                                    >
                                                        {item.expense_data[0]?.admin_status === "pending"
                                                            ? "Pending For Admin Approval ⌛"
                                                            : item.expense_data[0]?.admin_status === "rejected"
                                                                ? `Admin Rejection Reason : ${item.expense_data[0]?.admin_rejection_reason}`
                                                                : `Admin${item.expense_data[0]?.admin_update_by ? `(${item.expense_data[0]?.admin_update_by}-${item.expense_data[0]?.admin_update_by_name}) ` : ''}: Approved After Final Verification  ${item.expense_data[0]?.admin_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.admin_update_datetime).date}` : ''}`}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={item.expense_data[0]?.account_status_b}
                                                        className="request-status "
                                                    >
                                                        {item.expense_data[0]?.account_status_b === "pending"
                                                            ? "Final Stage Pending⌛"
                                                            : item.expense_data[0]?.account_status_b === "rejected"
                                                                ? `Final Rejection Reason : ${item.expense_data[0]?.account2_rejection_reason}`
                                                                : `Final${item.expense_data[0]?.final_update_by ? `(${item.expense_data[0]?.final_update_by}-${item.expense_data[0]?.final_update_by_name}) ` : ''}: Approved And Settled ${item.expense_data[0]?.final_update_datetime ? `At: ${formatDateTime(item.expense_data[0]?.final_update_datetime).date}` : ''}`}
                                                    </span>
                                                </td>
                                            </>
                                        ) : (
                                            <td colSpan={4} className="table-body align-center" style={{ verticalAlign: "top" }}>
                                                - No Expense Details Updated Yet -
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}

                            {/* ================= LOADING MORE INDICATOR / OBSERVER TARGET ================= */}
                            {page < totalPages && (
                                <tr ref={observerTarget}>
                                    <td colSpan={11} style={{ textAlign: "center", padding: "20px" }}>
                                        {loadingMore ? (
                                            <div className="spinner"></div>
                                        ) : (
                                            "Scroll for more"
                                        )}
                                    </td>
                                </tr>
                            )}

                            {/* ================= NO DATA MESSAGE ================= */}
                            {filteredImprestExpenseData.length === 0 && !buffer && (
                                <tr>
                                    <td colSpan={11} style={{ textAlign: "center", padding: "20px" }}>
                                        No data found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    }
                </table>
            </div>
        </div>
    );
};



export {
    AddProjectFromImprest,

    EmployeeImprestExpenseDashboard,
    ImprestExpenseDashboard
};
